export const len = {
    home: 'Home',
    manual: `Don’t know how to logon and upload PBC files to KCC? Click <a class="help-popover-text" href={href} target="_blank"> here </a> to see a short demonstration video.<br>如何登录KCC并上传PBC文档至KCC呢？点击<a class="help-popover-text" href={href} target="_blank"> 这里 </a>查看操作演示。`,
    manual2: '点击Contact for support弹出客户给KDC公邮提交运维support的界面。包含上传附件',
    login_tip: 'How to login?',
    login_out: 'Logout',
    help_tip: 'Contact us',
    support_order: 'Contact us',
    problem_description: 'Description',
    problem_description_null: 'Please enter description！',
    order_file: 'Attachments',
    i18n_btn: '切换中文',
    btn_resetPassword: 'Change password',
    btn_resetUserName: 'Change user name',
    btn_confirm: 'Confirm',
    btn_know: 'OK',
    btn_cancel: 'Cancel',
    btn_close: 'Close',
    btn_search: 'Search',
    btn_search2: 'Search',
    btn_submit: 'Submit',
    btn_add: 'Add',
    btn_add_1: 'Add One',
    msg_success: 'Success',
    msg_save_success: 'Save success',
    msg_submit_success: 'Submit success',
    msg_error: 'Failed',
    send_msg_success: 'Sent',
    unsend_msg: 'Unsent',
    msg_delete_sure: 'This operation will delete the data. Do you want to continue?',
    sel_msgList_delete_sure: 'This operation will delete the selected data. Do you want to continue?',
    msg_submit_sure: 'This operation will submit the data. Do you want to continue?',
    login_account: 'E-mail',
    login_forget: 'Forgot password',
    login_passWorld: 'Password',
    login_verification_Code: 'Verification Code',
    login_btn_getCode: 'Get Code',
    login_btn_login: 'Login',
    login_msg_success_login: 'Login success',
    login_msg_err_account: 'Illegal account',
    login_old_passWorld: 'Old password',
    login_new_passWorld: 'New password',
    login_renew_passWorld: 'Confirm New Password',
    login_password_hints:
        '<b>Password Rules: </b><br/>1. Password must have 12 characters length at least.<br/>2. Password must contain any three of the following four qualifications: <br/>  - Contain uppercase characters;<br/>  - Contain lowercase characters;<br/>  - Contain alphanumeric characters;<br/>  - Contain special characters (!@#$%^&*()) in English input method;<br/>3. The new password can not duplicate with the previous 14 historical passwords!',
    login_password_note:'<b>Things to note when creating a strong password:</b><br>-Avoid using simple sequences and personal information (e.g. names, phone numbers, birthday, etc.);<br>-Do not write your password down on paper or anywhere else;<br>-Use sentence/phrase to make it easier to remember (e.g. I love to eat pizza on Fridays! > IltEpoF2024!)',
    login_btn_back: 'Back',
    login_btn_confirm: 'Confirm',
    login_new_userName: 'Enter new user name',
    dictionary_matterLog_status_being: 'Being Addressed',
    login_read_terms: 'I have read and agree with this',
    login_terms: 'Terms of Use',
    person_info_collect: 'Notification & Consent Statement',
    set_session_title: 'Please set your session timeout',
    outTimeTips: 'You will be automatically logged out of the KCC system if no operation in this defined time slot.',
    dictionary_matterLog_status_open: 'Open',
    dictionary_matterLog_status_close: 'Closed',
    newComments:{
        title:'{num} new comment(s) posted by {role} today!',
        dlgTitle:'{role} New Comment(s) Today',
        kpmg:'KPMG',
        client:'Client'
    },
    ENTITY_ROOT_DELETE: 'Root node can not delete!',
    ENTITY_NODENAME_DUPLICATE: 'Node name can not duplicate!',
    return_prev_page: 'Return to previous page',
    return_home_page: 'Back to home',
    page_undefined: 'The page you visited does not exist',
    COMMON_DATA_NOT_EXIST: 'data does not exist',
    largeSizeFileAlertContent:
        'To ensure you experience the optimal download speed, the files size in one batch should be within {size}. Please adjust the files list and try again.',
    largeSizeFileAlertTitle: 'Files size exceeds the download limit!',
    btn_ok: 'OK',
    howToUploadPBCFile: 'PBC upload demo',
    howToConfigureKCCSite: 'Site set-up demo',
    howToDownloadPBCFiles: 'PBC download demo',
    Contact: 'Contact us',
    configTimeout: 'Configure timeout',
    configTimeoutDialogTitle: 'Configure the desired valid logon duration',
    trainingVideo: 'Short training videos',
    hour: 'hour',
    minute: 'minute',
    second: 'second',

    //menu
    home000: 'Home',
    system000: 'System Admin',
    system001: 'KPMG User Management',
    system002: 'System Admin Management',
    system003: 'Site Management',
    system004: 'Master Data Management',
    system005: 'Audit Trail',
    system006: 'Security Auditor',
    system007: 'Home News Management',

    site000: 'Site Management',
    site001: 'General Settings',
    site002: 'Client Roles',
    site003: 'Client Users',
    site004: 'KPMG Team Roles',
    site005: 'KPMG Team Members',
    site006: 'Close Out And Roll Forward To Next Year',
    site007: 'Clients Files Downloading Records',
    site008: 'Component Team Roles',
    site009: 'Component Team Members',
    site008_settingHome: 'Component Team Roles',
    site009_settingHome: 'Component Team Members',

    client000: 'Client Home',
    client001: 'Provided by Client (PBC)',
    client002: 'Statutory Accounts Status',
    client003: 'Matter Logs',
    client004: 'KPMG Executive Education (KEE)',
    client005: 'Joint Working',
    client005_2: 'IT Understanding',
    client006: 'Audit Confirmation',
    client007: 'Group Reporting',
    client008: 'Client Admin',
    client008_tips: '(*Client users that are authorised of this role can view all content in the selected tabs below.)',
    client001_des: 'Efficient and transparent information submission and tracking',
    client002_des: 'Real-time completion status of audit of the statutory accounts',
    client003_des: 'Matters timely communicated to facilitate resolution and to avoid surprises',
    client004_des: 'Interesting, informative, and storytelling!The growth partner of our client. ',
    client005_des: 'Easy file sharing with clients & Online questionnaire of client ‘IT Understanding’',
    client006_des: 'Timely audit confirmation authorisation and tracking',
    client007_des: 'Online collaborate with your KPMG component teams',
    client008_des: 'Summary of Fee invoices &  e-Fapiaos, VAT information, Engagement contracts, and Fee agreements.',
    ROLE_client001: 'A-Provided by Client (PBC)',
    ROLE_client002: 'F-Statutory Accounts Status',
    ROLE_client003: 'G-Matter Logs',
    ROLE_client004: 'E-KPMG Executive Education',
    ROLE_client005: 'B-Joint Working',
    ROLE_client006: 'C-Audit Confirmation (*check the box to access all confirmations)',
    ROLE_client007: 'H-Group Reporting',
    ROLE_client008: 'D-Client Admin',

    courseList: 'Course List',
    csConsult: 'CS Consult',
    myCourse: 'My favourite',
    courseDetail: 'Course Detail',
    myCourses: 'My history',
    myFafourite: 'My favourite',

    DIRECT_DATA_EXTRACTED: 'Direct Data Extraction',
    MANAGEMENT_REPORTS: 'Existing Management Reports',
    SUPPORTING_DOCUMENT: 'Other Supporting Document',
    ANALYSIS: 'Specific Analysis for Audit',
    NOT_APPLICABLE_CLIENT: 'Not Applicable(by client)',
    NOT_APPLICABLE_KPMG: 'Not Applicable(by KPMG team)',
    CHANGE_SOURCETYPE_NO_APPLICATION_WARNING:
        'Files uploading will be blocked if you set it to ‘Not Applicable’. Are you sure to continue?',
    groupReportingTip:
        'To comply with the data cross-border control requirements, this Group Reporting tile can not be switched off once it is activated. Should you need to switch it off, please contact the KCC Team!',
        newsMgt:{
            kccNews:"What's new?",
            usefulDocument:'Communicate with client',
            materials:'KCC Training Materials',
            seq:'#',
            newsTitle:'Title',
            newsDesc:'Desc',
            linkText:'Link Text',
            linkUrl:'Link URL',
            newsOrder:'Order',
            newsImage:'Image',
            docCategory:'Category',
            docCatalog:'Sub-category',
            docName:'Document Name',
            hyperlink:'Hyperlink',
            docOrder:'Order',
            materialTitle:'Title',
            materialCategory:'Category',
            materialOrder:'Order',
            materialImage:'Image',
            title1:"KCC News",
            title2:'About KCC',
            title3:'Client Communications',
            title4:'KCC overview',
            videoIntroduction:'KCC Introduction Video',
            videoList:{
                introduction:'KCC Introduction Video(2024 New)',
                introductionClient:'KCC Introduction Video',
                newlyLaunched:"KCC newly launched 'Audit Confirmation' tile",
                cn:'Mandarin',
                en:'English',
                yueyu:'Cantonese'
            },
            learningCourse:'KCC e-Learning course',
            overview:'KCC Overview',
            scanTips:'Scan the QR code to take a look',
            serviceDesk:'KCC Site Set-up Services',
            contactTeam:'Contact KCC Team',
            publish:'Publish',
            publishTitle:'Confirm to publish?',
            publishTips:"The updates will be immediately effective to all KPMG users' sites dashboard.",
            status:{
                0:'Draft',
                1:'Published'
            }
        },

    STATUS_DAYS_OVERDUE: {
        _1: 'Overdue within ',
        _2: ' days',
        _3: 'Overdue'
    }, // 'days overdue',
    STATUS_DAY_UNTILDUE: {
        _1: 'Due within ',
        _2: ' days',
        _3: 'dayUntildue',
        _4: 'Upcoming due',
        _5: ' days'
    }, // 'days until due',

    ROUTRE_META_1: 'Manage PBC List(s)',

    COMMON_001: 'Request argument not valid!',
    COMMON_004: 'You do not have current operating permissions!',
    COMMON_005: 'The whitelist is not set',
    COMMON_006: "The user's mailbox is not yet whitelisted",

    CLIENT_USER_002: 'Wrong user name or password 用户名或密码错误',
    CLIENT_USER_003: 'Same user account already exists on this KCC site:',
    CLIENT_USER_004: 'This user account (email address) does not exist! ',
    CLIENT_USER_006: 'Incorrect verification code',
    CLIENT_USER_007: 'The old password is wrong!',
    CLIENT_USER_008: 'The original password entered cannot be the same as the new password',
    CLIENT_USER_010:
        '<b>Password Rules: </b><br/>1. Password must have 12 characters length at least.<br/>2. Password must contain any three of the following four qualifications: <br/>  - Contain uppercase characters;<br/>  - Contain lowercase characters;<br/>  - Contain alphanumeric characters;<br/>  - Contain special characters(!@#$%^&*());<br/>3. The new password can not duplicate with the previous 14 historical passwords!',
    CLIENT_USER_011: 'The new password can not duplicate with the previous 14 historical passwords！',
    CLIENT_USER_012: 'You can only change your password once a day',
    CLIENT_USER_013: 'The account has been locked, please try again 30 minutes later.',
    CLIENT_USER_014:
        'This password reset link has expired! Please click on “Forgot Password” to retrieve the link again. ',
    CLIENT_USER_015: `The user is currently responsible for confirmation, please remove the user from the current Client confirmation responsible person list and upload the revised list to OAK system first, then remove the user from the KCC site. <br />*Ticket No can be viewed in Audit Confirmation Module after filtering "Responsible Person of the Audited Entity”.`,
    USER_IP_NOTAVALIABLE: `<span>Your access IP address [{ip}] is not in whitelist! Please contact your KPMG engagement manager for assistance!</span>`,
    USER_IP_NOTAVALIABLE_2: `<span>Your access IP address is not in whitelist! Please contact your KPMG engagement manager for assistance!</span>`,
    WHITELIST_DELETE_ERROR: 'The whitelist has is bound to client users and cannot be deleted',
    verification_code_send_success4Email:'<div>Success! The verification code has been sent to your email address and is valid for 30 minutes.</div>',
    verification_code_send_success4SMS:'<div>Success! The verification code has been sent to your mobile phone and is valid for 30 minutes.</div>',

    SYS_USER_001: 'User account already exists',
    SYS_USER_002: 'This user has already added this role',
    SYS_USER_003: 'Bad request',
    SYS_USER_004: 'Can not delete',
    SYS_USER_005: 'The last system admin can not be deleted',
    SYS_USER_006: 'The user is site admin, can not delete',
    SYS_USER_007: 'Kpmg user does not exist',
    SYS_USER_008: 'User does not exist',
    SYS_USER_009: 'Only allowed mainland person as administrators',
    SYS_USER_010: 'System admin can not be security manager',
    SYS_USER_011: 'Import excel empty',

    SITE_001: 'The site title already exists',
    SITE_002: 'Site already exists for this user and cannot be added repeatedly',
    SITE_003: 'The last site admin can not be deleted',
    SITE_004: 'Site title must be unique and can not contain any of the following characters:  / : , * ? < > |',
    SITE_005: 'EngagementMasterCode already exists and cannot be added repeatedly',
    SITE_006: 'EngagementMasterCode already has multiple duplicates and cannot be added repeatedly',
    SITE_007: 'This code has been associated with KCC sites and cannot be associated with other KCC sites!',
    SITE_008: 'This code has been roll forward and cannot be associated with other KCC sites!',
    INSIGHT_001: 'Insight name already exists',
    INSIGHT_002: 'The number of Insight items cannot exceed 14',
    MEMBER_ADD_GROUP_SECTION: 'Operation failed! To add group auditor team members, please go to "KPMG Team Members" card.',
    COMPONENT_ADD_MEMBER_SECTION: 'Operation failed! To add component team members, please go to "Component Team Member" card.',

    ROLE_001: 'Role name already exists',
    ROLE_002: 'The role name cannot be empty or space.',
    ROLE_003: `<span>Unable to update, Security admin or system admin [{security_admin}] cannot be set as a site admin</span>`,

    ENTITY_001: 'Entity name already exists',
    ENTITY_002: 'Entity name can not contain any of the following characters:  / : * ? < > |',
    ENTITY_003: 'Entity name not be blank.',

    FILE_UPLOAD_001: 'Can not upload',
    FILE_UPLOAD_002: 'The upload file relative path is blank',
    FILE_UPLOAD_003: 'Cannot upload files of this type',
    FILE_UPLOAD_004: 'File name cannot have spaces',
    FILE_UPLOAD_005: 'The upload file list is empty',
    FILE_LIST_TITLE: 'Files List',
    FILE_TOTAL_SIZE_HINT: 'Unknown file size exists, current total size > {size}',
    FILE_SELECTED_SIZE_HINT: 'Current total size: {size}',
    FILE_NONE_DOWNLOAD: 'Select files without download records',
    FILE_SELECT_ALL: 'Select all',
    FILE_SELECT_INVERSE: 'Invert selection',
    FILE_SELF_NONE_DOWNLOAD: 'Select files without my download records',
    FILE_OVER_SIZE_ALERT: 'Please reduce the selected files to < {size} in total, to experience good downloading performance.',
    FILE_DOWNLOAD_001: 'Can not download',
    FILE_DOWNLOAD_002: 'The downloaded file directory cannot be empty',
    FILE_DOWNLOAD_003: 'The downloaded file does not exist',

    FILE_DELETE_001: 'Can not delete',
    FILE_DELETE_002: 'The file name is blank',
    FILE_DELETE_003: 'The file relative path is blank',
    PBC_GROUP_ADD_001: 'PBC list name is already existed',
    PBC_GROUP_ADD_002: '保存失败！已创建好的PBC清单中已存在“年终/中期&客户实体&期末日期&会计科目&数据要素”均相同的PBC条目，请勿重复创建！',
    PBC_LIST_ADD_ERR: 'Entity or Account is empty!',

    PBC_GROUP_DELETE_001: "Some client users have uploaded files to this PBC list!Can't be deleted!",

    PBC_GROUP_UPDATE_001: 'Cannot update pbc, has already upload file',
    PBC_GROUP_QUERY_001: 'PBC information is not found',
    COPY_PBC_GROUP_001: 'Cannot copy final pbc group',
    CHANGE_PBC_STATUS_001: 'PBC status is not uploaded and cannot be modified',

    FILE_IMPORT_001: 'The file that needs to be uploaded does not exist.',
    FILE_IMPORT_002: 'Import file is not Excel2007 or above',
    FILE_IMPORT_003: 'Import failed',
    FILE_IMPORT_004: '导入模板中，“已识别的相关数据要素”部分单元格内容过多！不可超过250个汉字 （或250个英文字母）！',

    MESSAGE_ERROR01: 'Please enter the message',

    MASTER_DATA_ADD_001: 'Master data added failed',
    MASTER_DATA_ADD_002: 'Subject is already existed',
    MASTER_DATA_INVALID_001: 'Master data name can not contain any of the following characters:  / : , * ? < > |',

    file_upload_failed: 'Upload failed!',
    file_upload_success: 'Upload success!',
    file_upload_success2: `<span>Submit success!<br>KPMG KCC Help Desk has received your information and will give you feedback as soon as possible! Feedback will be sent to your registered email address[{email}]. </span>`,
    file_import_success: 'Import Success!',
    record_is_exist: '该PBC清单中存在”会计科目“”数据要素“均相同的PBC条目，请勿重复创建！',
    record_is_exist1: '该PBC清单中存在”会计科目“”数据要素“均相同的PBC条目，请勿重复创建！',
    account_upload_info: 'Duplicated PBC items will be ignored. (same Account+same Relevant Data Elements)',
    account_check_error: 'Please enter your account!',
    deactivated_error:
        'Your KCC account has been deactivated (possibly due to your long absence from logging in)! Please contact your KPMG engagement manager for help.',
    forget_pass_world: 'Reset password mail has been sent！',
    client_user_dele_warning: 'This user cannot delete!',
    clientRoles_delete_sure: 'The deletion may impact some client user’s access to this KCC site content. Are you sure to continue?',
    kpRoles_delete_sure: 'The deletion may impact some KPMG team member’s access to this KCC site content. Are you sure to continue?',
    client_user_add_warning: `<span style="color:#fd349c;">Important Notice of cross-border data policies!<br><ul><li>If this KCC site is for a KPMG Huazhen Mainland China engagement: In order to be legally allowed to access KCC, please confirm that this invited client user is an employee of the client and is located in Mainland China.</li><li>If this KCC site is for KPMG Hong Kong engagement: please do not grant access to Mainland China client users!</li></ul></span>`,
    client_user_add_warning2:
        'Before sending user the initial password, please first assign user access permissions, including "Access Level” and “Authorised Client Entities or Roles”!',
    full_screen: 'Full screen',
    full_no_screen: 'Cancel full screen',
    comment_reSet: 'Cancel',
    comment_send: 'Send',
    import_file_type_error: 'Import template can only be in excel format!',
    import_img_type_error:'Please import Image',
    import_file_size_error: 'Import template must less than 5MB!',
    import_tpl_size_100k_error: 'Import template must less than 100KB!',
    import_file_size_100k_error:'Import picture must less than 100KB',
    NODE_DELETE_ERROR:
        'The entity cannot be deleted as it is linked to a role or associated with the matter logs and/or statutory account status or associated with PBC List',
    MENU_CHECKED_ERROR:
        'Failed to close! This section has been associated with a customer role. Please remove the association in the customer role configuration and try again!',

    ILLEGAL_USER_INPUT_01: 'Can not contain any of the following characters:  \\ / : * ? < > | ” “ " , ，',
    ILLEGAL_USER_INPUT_02: 'illegal user input of \\ / : * ? < > | ” “ " ',
    ILLEGAL_USER_INPUT_03: 'The password does not comply with the requirements! Please refer to the password rules on the left.',
    ILLEGAL_USER_INPUT_04: 'Can not contain any of the following characters:\\ / : * ? < > | ” “ " , ，',
    ENTER_SEARCH_CONTENT: 'Please enter the search content',
    CLIENT_HOME_CONTACT: 'Client contact',
    CLIENT_HOME_KPCONTACT: 'KPMG contact',
    COMMON_INTERIM: 'Interim',
    COMMON_FINAL: 'Final',
    FORM_VALIDATE_REQUIRED: 'Required！',
    FORM_VALIDATE_URL: 'invalid URL',
    FORM_VALIDATE_LOGIN_MAX: 'A minimum password length of 12 characters is required!',
    FORM_VALIDATE_LOGIN_MAX8: 'A minimum password length of 8 characters is required!',
    TERM_OF_USE_MUST_BE_AGREED: 'Please read and agree.',
    FORM_VALIDATE_PASSWORLD: 'Please key in your password!',
    FORM_VALIDATE_ACCOUNT: 'Enter account！',
    FORM_VALIDATE_RENEW_PASSWORD: 'Confirm New Password',
    FORM_VALIDATE_OLD_PASSWORD: 'Enter old password！',
    FORM_VALIDATE_NEW_PASSWORD: 'Enter new password！',
    FORM_VALIDATE_NEW_PASSWORD_INCONSISTEN: 'Inconsistent passwords！',
    FORM_VALIDATE_DUPLICATE_KEY: 'No duplicate keys',
    FOOTER_LEGAL: '<a style="color: blue;" href="https://home.kpmg/cn/en/home/misc/legal.html" target="_blank">Legal</a>',
    FOOTER_PRIVACY: '<a style="color: blue;" href="https://home.kpmg/cn/en/home/misc/privacy.html" target="_blank">Privacy</a>',
    FOOTER_DES:
        ' KPMG Technology Services (Hong Kong) Limited, a Hong Kong (SAR) limited liability company and a member firm of the KPMG global organisation of independent member firms affiliated with KPMG International Limited, a private English company limited by guarantee. All rights reserved. <br />The KPMG name and logo are trademarks used under license by the independent member firms of the KPMG global organisation.',
    LOGIN_PAGE_DES:
        'Hints:Password should contain any three of the following four qualities:Uppercase Characters,Lowercase Characters,Alphanumeric Characters,Special Characters <!@#$%^&*()> with 8 characters at least.提示：密码应包含以下四种品质中的任意三种：大写字母，小写字母，字母数字字符，特殊字符<！@＃$ %% ^＆*（）>至少具有8个字符',
    LOGIN_PAGE_CHANGE_TITLE: 'Change password',
    btn_save: 'Save',
    COMMON_EXPORT: 'Export',
    COMMON_ADD_ITEM: 'Add new Item',
    MATTER_ADD_ITEM: 'Add New Item',
    COMMON_UPDATE_START: 'Update Start',
    COMMON_UPDATE_END: 'Update End',

    TABLE_HEADER_ENTITIES: 'Entities',
    TABLE_HEADER_FISTDRAFTRECEIVED: '1st Draft Received From Client',
    TABLE_HEADER_TARGET_OF1ST_DRAFT: 'Target Date',
    TABLE_HEADER_UNDERREVIEWD: 'Under KPMG Internal Review',
    TABLE_HEADER_AWAITINGADDITION: 'Awaiting Additional  Information From Client',
    TABLE_HEADER_peddingFinalApproval: 'Client Approval Of Final Draft',
    TABLE_HEADER_finalisation: 'Printing And Binding',
    TABLE_HEADER_clientSignOff: 'Client Sign-off',
    TABLE_HEADER_kpmgSignOff: 'KPMG Sign-off',
    TABLE_HEADER_TARGET_OF_SIGN_OFF: 'Target Date Of Sign-off',
    TABLE_HEADER_STATUS: 'Status',
    TABLE_HEADER_KPUSER: 'Responsible',
    TABLE_HEADER_MODIFY_RECORD: 'Status Records',
    MODIFY_HEADER_BEFORE: 'status before modify',
    MODIFY_HEADER_AFTER: 'status after modify',
    SET_DUEDAYALARM: 'Configure auto-reminder',
    TABLE_HEADER_DUEDAY: 'Group Auditor Set Due Date',
    TABLE_HEADER_CONFIRM_DUEDAY: 'Component Team Confirmed Due Date',
    COMMON_DAY: 'day(s)',
    TIME_OPTION: 'Option',
    COMMON_PERIOD: '{msg} alarm',
    DUEDAY_WARNING: 'No email notification will be trigger if no Responsible person is assigned.',
    SET_DUEDAYALARM_MESSAGE: 'Configuration failed, please exit the interface and try again',
    SET_DUEDAYALARM_MESSAGE2: 'The period cannot be blank or zero',
    SET_DUEDAYALARM_MESSAGE3: 'Only allow Integer',
    TABLE_HEADER_DATE: 'Actual Date',

    TABLE_HEADER_title: 'Title',
    TABLE_HEADER_title2: 'Title',
    TABLE_HEADER_matter: 'Matter',
    TABLE_HEADER_entityList: 'Client / Entity / Sub-entity',
    TABLE_HEADER_category: 'Financial <br/> Statement Caption',
    TABLE_HEADER_category_placeholder: 'Financial Statement Caption',
    TABLE_HEADER_Issues: 'Matter / Issue Status',
    TABLE_HEADER_Deficiency: 'Matter / Issue Type',
    TABLE_HEADER_Adjustment: 'Potential Audit Adjustment',
    TABLE_HEADER_Difference: 'Misstatement',
    TABLE_HEADER_Description: 'Matter / Issue <br/> Description',
    TABLE_HEADER_Description_placeholder: 'Matter / Issue Description',
    TABLE_HEAD_EntityList: 'Client Entities / Sub-entities',
    TABLE_HEAD_EntityList_group: 'Components',
    TABLE_HEAD_EntityList2: 'Components',
    select_category: 'Create Folder Category',
    select_entity: 'Select Applicable Client Entities',
    select_entity_group: 'Select Applicable Components',
    TABLE_HEAD_Category: 'Folder Category',
    custom_folder_category: 'Create a tailored folder category',
    TABLE_HEADER_EXCHANGE_STATUS: 'Status',
    ECHANGE_STATUS: {
        _1: 'Initiated',
        _2: 'Submitted To Group',
        _3: 'Revision Required',
        _4: 'Approved By Group Team'
    },
    EXCHANGE_CATEGORY: {},
    TABLE_HEAD_COMMENTS: 'Comments',
    PAGE_EXCHANGE_TAB1: 'Files Sharing with Client',
    PAGE_EXCHANGE_TAB1_for_clientrole: 'Joint Working',
    PAGE_EXCHANGE_TAB2: 'Group Reporting - Deliverables Collection',
    PAGE_EXCHANGE_TAB3: 'Group Reporting - Shared Documents',
    PAGE_EXCHANGE_TAB4: 'IT Understanding',
    EXCHANGE_BATCH_STATUS: 'Change Status',
    EXCHANGE_BATCH_DEADLINE: 'Change Deadline',
    EXCHANGE_BATCH_KPUSER: 'Change Responsible',
    ENTITY_CATEGORY_001: 'This record is exist,please do not add it repeatedly!',
    ENTER_CATEGORY_LIST: 'please enter category',
    ENTER_ENTITY: 'please input or select entity/Sub-entities',
    entity: 'Entity',
    subEntity: 'Sub-entity',
    demo_site: 'Demo Site',

    FORM_LABEL_matterType: 'Matter / Issue Type',
    FORM_LABEL_Organization: 'Client / Entity / Sub-entity',
    FORM_LABEL_kpmgOwner: 'KPMG Owner',
    FORM_LABEL_clientOwner: 'Client Owner',
    FORM_LABEL_status: 'Status',
    FORM_LABEL_priority: 'Priority',
    FORM_LABEL_relatedIssue: 'Related Issues',
    FORM_LABEL_description: 'Description',
    FORM_LABEL_attachmentList: 'Uploaded Files',
    FORM_LABEL_attachmentList_short: 'Files',
    PAGE_MATTERLOG_UPLOAD_TIP:
        'Upload files can only be in xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg,and no greater than 2G for each file',
    PAGE_MATTERLOG_UPLOAD_TIP1: 'Need to click the save button to bind these attachments together with the matter log',
    PAGE_MATTERLOG_COMMENTS: 'Comments',
    PAGE_MATTERLOG_REPLY: 'Reply',
    PAGE_MATTERLOG_DUDATE: 'Due Date Proposed by KPMG',
    KPMG_Due_Date: 'KPMG Due Date',
    PAGE_MATTERLOG_BRIEFCOMMENT: 'Brief comment',
    PAGE_MATTERLOG_DUDATE_BY_CLIENT: 'Due Date Confirmed by Client',
    Client_Confirmed_Due_Date: 'Client Confirmed Due Date',
    PAGE_MATTERLOG_SOURCE_OF_INFORMATION: 'Source Of Information',
    PAGE_MATTERLOG_UPLOAD_LIMIT: 'Allow up to 3 files to be uploaded',
    PAGE_MATTERLOG_UPLOAD_TYPE:
        'Upload files can only be in xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg format!',
    PAGE_MATTERLOG_UPLOAD_SIZE: 'The upload file size cannot exceed 2G!',

    PAGE_PBC_CHANGETO: 'Change to',
    PAGE_PBC_COMMENTS: 'Comments',
    COMMON_SELECT: 'Select',
    COMMON_INPUT_AND_SELECT: 'please input or select',
    TABLE_HEADER_topicName: 'Accounts',
    TABLE_HEADER_sub_topicName: 'Sub Accounts',
    TABLE_HEADER_periodEndDate: 'Period End Date',
    TABLE_HEADER_Message: 'Message',
    TABLE_HEADER_clientUserName: 'Client Responsible Preparer/Provider',
    client_user_email_keyword: 'Client Email (Keyword)',
    TABLE_HEADER_kpmgUserName: 'KPMG Responsible Reviewer',
    TABLE_HEADER_uploadedBy: 'Last Uploaded By',
    TABLE_HEADER_detailedInfoReq: 'Detailed Information Request',
    TABLE_HEADER_uploadedDate: 'Last Uploaded Time',
    TABLE_HEADER_fileNameList: 'Uploaded Files',
    TABLE_HEADER_Action: 'Action',
    DASHBOARD_TAB_TIP: 'Custom items are displayed in Account and sub-account and the content is the same',
    DASHBOARD_TOTAL: 'Grand Total',
    COMMON_CHANGESTATUS: 'Update Status',
    COMMON_CHANGESTATUS_COMMENTS: 'Status comments',
    COMMON_DOWNLOAD: 'Download',
    BATCH_DOWNLOAD: 'Batch Download',
    COMMON_CHOOSE: 'Select',
    COMMON_ING: 'ing',
    COMMON_UPLOAD_START: 'Last Uploaded Start',
    COMMON_UPLOAD_END: 'Last Uploaded End',
    COMMON_UPLOAD_DATE: 'Last Uploaded Time',
    COMMON_DUE_START: 'KPMG Proposed Due Date',
    COMMON_DUE_END: 'KPMG Proposed Due End',
    COMMON_PERIODEND_START: 'Period End Date',
    COMMON_PERIODEND_END: 'Period End Date',
    COMMON_SET_STATUS: 'Update Status by Batch',
    COMMON_COPY_INTERIM: 'Copy PBC List(s) from Interim',
    COMMON_PBC_LIST: 'Set Up PBC List(s)',
    pbc_change_tips: 'You updates have not been saved! Are you sure to continue? ',
    COMMON_PBC_TITLE_LIST: 'A - PBC Lists',
    COMMON_CLEAR_BTN: 'Reset',
    COMMON_CATEGORY_LIST: 'Files Sharing with Client',
    PAGE_PBC_LIST_DETAILED: 'Configure PBC List',
    BASE_INFO: 'Base Information',
    step_1: 'Select Applicable Client Entities',
    step_2: 'Select Accounts',
    PAGE_PBC_LIST_NAME: 'List Name',
    PAGE_PBC_LIST_TOPIC: 'Accounts',
    standardAccounts: 'Standard Accounts',
    PAGE_PBC_LIST_TOPIC_CUS: 'Tailored Accounts',
    PAFE_PBC_LIST_DESC: 'Relevant Data Elements',
    PAGE_PBC_LIST_SELECT_TOPIC: 'A - PBC Lists Items',
    PAGE_PBC_LIST_EDITCHILD: 'Batch Edit Child',
    PAGE_PBC_LIST_EDITCHILDDATE: 'Batch Edit Date',
    PAGE_PBC_LIST_CEHCK_DUEDATE: 'The Due Date Proposed by KPMG cannot be empty when checked.',
    PAGE_PBC_ADD_TOP: 'Add tailored PBC item',
    PAGE_PBC_ACCOUNT_DES: 'Request Details',
    IMPORT_ACCOUNT_BTN: 'Import tailored accounts',
    batchImport: 'Batch Import',
    COMMON_ADD: 'Add Item',
    COMMON_UPLOAD: 'Upload',
    PAGE_PBC_UPLOAD_TIP:
        'Up to {size} files can be uploaded; each single file size should be no greater than 1GB! File formats that are supported: xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    PAGE_PBC_UPLOAD_TIP_1:
        'Each single file size should be no greater than 1GB! File formats that are supported: xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    PAGE_PBC_UPLOAD_text1: 'drag files here,or',
    PAGE_PBC_UPLOAD_text2: 'click to choose',
    PAGE_PBC_UPLOAD_SIZE: 'The upload file size cannot exceed 1G!',
    PAGE_PBC_UPLOAD_LIMIT: 'Allow up to {size} files to be uploaded',
    PAGE_PBC_UPLOAD_LIMIT_80: 'Allow up to 50 files(include history version) to be uploaded',
    FILE_LIST_EMPTY_ALERT: 'No file found or not permitted to download!',
    PAGE_PBC_TOPIC_REPEAT: 'Duplicate topic name',
    PAGE_LOGIN_ERROR:
        'You are not yet authorised of any KCC site. Please contact your engagement manager (KCC Lite site manager) for authorisation and try again.\n您目前还没有任何被授权的KCC站点。请联系你的项目经理（KCC Lite站点管理员）进行授权后再尝试。',

    FORM_LABEL_siteName: 'Site title',
    FORM_LABEL_clientName: 'Client Name',
    siteTips1:'ALL uploaded files in this KCC site will be deleted automatically when its mapped engagement code is set to “Closed” in IBS!',
    siteTips2:'Roll-forward the existing KCC site structure to the current period’s audit work to recycle use it!',
    siteTips3:"Update this KCC site's currently mapped Opportunity code or Business development code to an IBS engagement code！",
    SET_WHITE_LIST: 'Set Email Whitelist',
    SET_IP_WHITE_LIST: 'Set IP Whitelist',
    SET_IP_WHITE_LIST_TITLE: 'Set IP whitelist',
    SET_WHITE_LIST_FIRST: 'Please first configure the Email whitelist!',
    WHITE_LIST: 'Whitelist',
    IP_WHITE_LIST: 'Ip whitelist',
    WHITE_LIST_DELE_WARNING: 'Are you sure you want to delete?',
    ENTER_WHITE_LIST_PLACEOLDER: 'Please enter client\'s working email address suffix "@client.com".',
    ENTER_IP_WHITE_LIST_PLACEHOLDER: 'Such as “127.0.0.1,127.0.0.2”',
    ENTER_WHITE_LIST: 'Enter whitelist！',
    ENTER_IP_WHITE_LIST: 'Enter ip whitelist!',
    WHITE_LIST_TIP: 'Whitelist aims to make sure all authorised client users are registered with their working email address.',
    IP_WHITE_LIST_TIP: 'No limitation by default. Set up access IP whitelist according to client IT security request!',
    EMAIL_IS_EXIST: 'Email is already exist,please enter another!',
    IP_IS_EXIST: 'Ip is already exist,please enter another！',
    OPERATE_ING_WARNING: 'Other operations are in progress. Please complete other operations first',
    FORM_LABEL_URL: 'URL',
    FORM_LABEL_Image: 'Image',
    PAGE_GENERAL_UPLOAD_SIZE: 'The upload file size cannot exceed 1M!',
    PAGE_GENERAL_UPLOAD_TYPE: 'Upload files can only be in jpeg/gif/png  format!',

    TREE_BTN_ADD_ENTITY: 'Add Entity',
    TREE_BTN_ADD_SUB: 'Add Sub-entity',
    COMMON_DELETE: 'Delete',
    TREE_BTN_MOVE_UP: 'Move Up',
    TREE_BTN_MOVE_DOWN: 'Move Down',
    COMMON_NAME: 'Name',
    TREE_BTN_ADD_ERROR: 'Please select the entity node and add Sub-entity!',
    TREE_BTN_MOVE_UP_ERROR: "It's already the first one!",
    TREE_BTN_MOVE_DOWN_ERROR: "It's already the last one!",

    PAGE_GENERAL: 'General',
    PAGE_GENERAL_TITLE1: 'Manage Client Organization Structure',
    PAGE_GENERAL_TITLE2: 'Manage Function Tiles',
    PAGE_GENERAL_TEST: 'Test',

    COMMON_EDIT: 'Edit',
    FORM_LABEL_siteAdmin: 'Site admin',
    FORM_LABEL_siteAdminCustom: 'Current Site Administrators',
    ADD_FORM_LABEL_siteAdmin: 'Add More Site Administrators',
    searchPlaceholder: 'Search staff name',

    PAGE_CLIENTROLES_TITLE: 'Client Roles',
    PAGE_CLIENTROLES_ADD: 'Add New Role',
    TABLE_HEADER_roleName: 'Role name',
    TABLE_HEADER_modifyDate: 'Modify Date',
    PAGE_CLIENTROLES_PERMISSION: 'Role permission',
    CLIENTROLE_ADD_STEP1: 'What entities will this client role access?',
    CLIENTROLE_ADD_STEP2: 'What tiles will this client role access?',
    CLIENTROLE_ADD_STEP3: 'What PBC lists, Joint Working or Client Admin content will this client role access?',
    CLIENTROLE_ADD_STEP4: 'What PBC lists items (tile A) will this client role access?',

    COMMON_ENTITY: 'Entity',
    COMMON_TILES: 'Tiles',

    PAGE_CLIENTUSER_TITLE: 'Client Users',
    COMMON_USER_NAME: 'User Name',
    PAGE_CLIENTUSER_EMAIL: 'Send Notification Email',
    PAGE_CLIENTUSER_EMAIL_PBC: 'Notify Client About Outstanding PBC',
    PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB0: 'Notify Client To Download Shared Files',
    PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB1: 'Notify Component To Submit Deliverables',
    PAGE_CLIENTUSER_PAD_EMAIL: 'Send Initial Password',
    sendTime: 'Send Date',
    PAGE_CLIENTUSER_ADD: 'Add New User',
    ADD_CLIENT_USER:'Add Client New User',
    EDIT_CLIENT_USER:'Edit Client User',
    client_identity_type:{
      '1':'employee of China mainland client',
      '2':'employee of HK/Macau client',
      '3':'employee of overseas client'  
    },
    PAGE_CLIENTUSER_EDIT: 'Edit user',
    COMMON_DOWNLOAD_TEMP: 'Download Template',
    COMMON_IMPORT: 'Import',
    COMMON_USER_ACCOUNT: 'User Account',
    USER_WORKING_EMAIL: "Client's Working Email Address",
    email_warn: "Do not use client's personal email address to register a KCC account, to avoid potential data leakage risks!",
    TABLE_HEADER_Roles: 'Roles',
    TABLE_HEADER_Roles_des:
        '*Each client user can always view the Confirmations that he/she is responsible for in ‘Audit Confirmation’ tile. To access all other KCC tiles, please configure and assign role(s) to client to authorise.',
    CLIENT_USERS_TIPS:
        'KPMG engagement team should regularly review the validity of the client KCC accounts, and disable or delete the ones that in short term or no longer need to access KCC.',
    cilentExportUserList: 'Export Users List',
    TABLE_HEADER_createTime: 'Creation Time',
    TABLE_HEADER_ifContact: 'Display as client contact',
    TABLE_HEADER_KPifContact: 'Display as KPMG contact',
    TABLE_HEADER_IfComponentMember: 'Component Member',
    TABLE_HEADER_CLIENT_IDENTITY: 'Client Identity',
    TABLE_HEADER_Active: 'Active',
    Activated: 'Account Activated?',
    account_yes: 'Disabled',
    account_no: 'Enabled',
    Last_Login: 'Last Login',
    Last_Active_Time: 'Recent Active Date',
    Date_Type: 'Active Type',
    Deactivate_Setting: 'Auto Disable Period (Inactive)',
    deactivate_setting: {
        _3: '3 months',
        _4: '4 months',
        _5: '5 months',
        _6: '6 months'
    },
    TABLE_HEADER_SuperFlag: 'Access all audit confirmations',
    TABLE_HEADER_EMAIL_STATUS: 'Email status',
    EMAIL_SEND_STATUS: 'Sent/Unsent',
    BACKUP_MAILBOX: 'Backup mailbox',
    BACKUP_MAILBOX_DESC: "Please be cautious to use client's personal email to avoid potential data leakage risks!",
    BACKUP_MAILBOX_WARNING:
        'This backup mailbox aims to address the possible issues that the client’s registered email address fails to receive the KCC initial password, logon verification code or password reset notifications, and needs be deleted timely!',

    PAGE_KPMG_TEAM_TITLE: 'KPMG Team Members',
    PAGE_KPMG_TEAM_OWNER: 'Engagement Partner',
    PAGE_KPMG_TEAM_MANGER: 'Engagement Manager',
    PAGE_KPMG_TEAM_ADMIN: 'Site Administrator(s)',
    TABLE_HEADER_EMAIL_StaffNo: 'Staff No',
    TABLE_HEADER_EMAIL_ProfitCenter: 'Profit Center',
    TABLE_HEADER_EMAIL_StaffName: 'Staff Name',
    TABLE_HEADER_EMAIL_Position: 'Position',
    TABLE_HEADER_EMAIL_Email: 'Email',
    TABLE_HEADER_CLIENTUSER: 'Client Users',
    PAGE_KPMG_ROLE_TITLE: 'KPMG User Roles',
    PAGE_KPMG_ROLE_TITLE_group: 'KPMG Team Roles',

    // KPMG User Management

    KPMG_USER_MANAGEMENT_TITLE: 'KPMG User Management',
    KPMG_USER_MANAGEMENT_PLACE_HOLDER: 'Staff No,Staff Name,Profit Center',

    //System Admin Management
    KPMG_SYSTEM_ADMIN_MANAGEMENT_TITLE: 'System Admin Management',
    KPMG_SYSTEM_ADMIN_MANAGEMENT_PLACE_HOLDER: 'Name,Staff No',

    //Site Management

    SITE_MANAGEMENT: 'Site Management',
    SITE_CODE_PLACEHOLDER: 'Site Code',
    SITE_PLACE_HOLDER: 'Site Title,Site Admin,Modified By',
    SITE_START_DATE: 'Start Date',
    SITE_TO: 'to',
    SITE_END_DATE: 'End Date',
    SITE_CLOSE_DATE: 'Code ‘Closed’ Time',
    SITE_DOWNLOAD_SITE: 'Export Sites',
    SITE_APPROVER: 'Approver',
    SITE_APPROVAL_DESC: 'Please fill in the approver .',
    SITE_OWNER_SHIP: 'Client Ownership',
    SITE_SERVICE_GROUP: 'Engagement PC Sub-function',

    SITE_SEARCH_NAME_KEYWORD: 'Site Title (Keyword)',
    SITE_SEARCH_CLIENT_KEYWORD: 'Client Name (Keyword)',
    SITE_SEARCH_ENTITY: 'Number of Entities',
    client_home: {
        kpTitle: 'Dashboard Key Data',
        clientTitle: 'My to-do list',
        workspace: 'Workspace',
        pbcItem: 'Outstanding PBC Items',
        duePbcItem: 'Due soon PBC Items',
        overduePbcItem: 'Overdued PBC Items',
        revisionPbcItem: 'Revision Required PBC Items',
        uploadPbcItem: 'Client upload PBC Items',
        confirmationItem: 'Outstanding Confirmations',
        stampingConfirmationItem: 'Pending for Authorisation',
        addressConfirmationItem: 'Received by addressees but not yet responded',
        mattersLogItem: 'Matters Log',
        solutionMattersLogItem: 'Matters pending for solution',
        executiveSummary: 'Executive Summary',
        executiveItem: 'Statutory Accounts Progress Overview',
        clientContact: 'Contact',
        recommendTitle: 'Recommendations to maximise KCC speed',
        more: 'More',
        accountsOverview: 'Statutory Accounts Progress Overview'
    },
    SITE_TABLE_HEADER_SITE_NAME: 'Site Title',
    SITE_TABLE_HEADER_SITE_TYPE: 'Site Type',
    SITE_TABLE_HEADER_SITE_ADMIN: 'Site Administrator(s)',
    SITE_TABLE_HEADER_CREATE_BY: 'Created By',
    SITE_TABLE_HEADER_CREATE_TIME: 'Created Time',
    SITE_TABLE_HEADER_MODIFIED_TIME: 'Modified Time',
    recent_action_time: 'Last Accessed',
    SITE_TABLE_HEADER_MODIFIED_BY: 'Modified By',
    SITE_TABLE_HEADER_IS_LLP: 'KPMG Huazhen Engagement',
    SITE_TABLE_HEADER_NUMBER_OF_ENTITIES: 'Number of Entities/Subsidiaries',
    SITE_TABLE_HEADER_ENGAGEMENT_CODE: 'Engagement Code',

    SITE_LABEL_SITE_OWNER: 'Engagement Partner',
    SITE_LABEL_SITE_MANGER: 'Engagement Manager',
    Site_NAME_INCORRECT_001: 'The “Client Name” in imported file should be same with the Client Name of this KCC site.',
    ENTITIES_ASSOCIATION_INCORRECT_001:
        'The existing Client organization structure already relates to roles, PBC lists or Category folders, and re-import is blocked!',
    ENTITY_IMPORT_010:
        "The 'Client name' of this KCC site duplicates with other existing KCC site. Please change the 'Client name' and try gain.",

    //Master Data Management
    MASTER_DATA_TITLE: 'Master Data Management',
    MASTER_DATA_PLACE_HOLDER: 'Subject',
    MASTER_DATA_TABLE_HEADER_ITEM_SUBJECT: 'Item Subject',
    MASTER_DATA_TABLE_HEADER_VALUE: 'Value',
    MASTER_DATA_ADD_KEY: 'key',
    MASTER_DATA_ADD_VALUE: 'label',
    PAGE_NEXTYEAR_POP_TITLE: 'Time Choice',
    PAGE_NEXTYEAR_ORG_TITLE: 'Client organization',
    PAGE_NEXTYEAR_INSIGHT_TITLE: 'KPMG Executive Education',
    PAGE_NEXTYEAR_CLIENT_TITLE: 'Client roles and users',

    PAGE_PBCLIST_NAME: 'PBC List Name',
    TABLE_HEADER_DETAILS: 'Details',
    COMMON_VIEW: 'view',
    COMMON_COPY: 'copy',
    COMMON_YES: 'Yes',
    COMMON_NO: 'No',

    AUDIT_TRAIL_TITLE: 'Audit Trail',
    AUDIT_TRAIL_TABLE_HEADER_ACCESS_URL: 'Access URL',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_IP: 'Operation IP',
    AUDIT_TRAIL_TABLE_HEADER_USER_AGENT: 'User Agent',
    AUDIT_TRAIL_TABLE_HEADER_USER_TYPE: 'User Type',
    AUDIT_TRAIL_TABLE_HEADER_OPERATOR: 'Operator',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_LOG: 'Operation Log',
    AUDIT_TRAIL_TABLE_HEADER_OPERATION_TIME: 'Operation Time',

    GLOBAL_SWITCH_ENTITY: 'Filter per Component',

    ACCOUNT_STATUS_CREATE_AT: 'Created at',
    ACCOUNT_STATUS_UPDATE_BY: 'Last update time at',
    ACCOUNT_STATUS_SPREAD_BY: 'by',
    ACCOUNT_STATUS_NOT_APPLICABLE: 'Not Applicable',
    ACCOUNT_STATUS_NOT_START: 'Not Started',
    ACCOUNT_STATUS_NOT_PROGRESS: 'In Progress',
    ACCOUNT_STATUS_NOT_COMPLETE: 'Completed',

    COMMON_PROJECT_NAME: 'KPMG  Collaboration Centre',
    NEW_COMMENT: 'New Comment',
    INTERIM_AUDIT: 'Interim Audit',
    OUTSTANDING: 'Outstanding',
    REVISION: 'Revision Required',
    UPLOADED: 'Uploaded',
    ACCEPTED: 'Accepted',
    COMPLETED: 'Completed',
    FORM_VALIDATE_EMAIL: 'Please input the correct email address',
    FORM_VALIDATE_IP: 'Please input the correct IP address',
    Overdue: 'Due Soon',
    DaysUntilDue: 'Overdued',
    few_days_later: 'days later',
    Overdue_days: 'days',

    FILE_DELETE_005: 'No permission to delete files',
    PBC_GROUP_UPDATE_002: 'Pbc list name is already existed',
    PBC_GROUP_COPY_001: 'The copied pbc name already exists in the year-end and cannot be copied.',
    EXPORT_DATA_001: 'Failed! Because the exported data entry exceeds the maximum value of 5000. Please filter by filter criteria.',
    FILE_DOWNLOAD_005: 'The download file storage name is null.',
    MASTER_DATA_QUERY_001: 'Master data has duplicate data value value',
    SAVE_ROLL_FOREARD_TASK_001: 'This operation has been performed, please do not submit again.',
    MASTER_DATA_INVALID_002: 'The name or value is blank.',
    INSIGHT_003: 'Insight title cannot be blank.',
    MASTER_DATA_INVALID_003: 'Subject name is blank.',
    USER_DELETE_001: 'The current user cannot delete yourself.',
    TOPIC_EDIT_001: 'Some client users have uploaded files to this PBC account!',
    SITE_APPROVER_VALIDATION_001: 'Invalid site approver format.',
    ROLL_FOREARD_TASK_TEXT1: 'All PBC files will be deleted in',
    ROLL_FOREARD_TASK_TEXT2: 'Days when close out current site！',
    CLIENT_ROLE_ENTITY_OR_TILES: 'Entity or tiles cant be empty！',
    PASSWORD_CHANGE_MESS: 'Your password is about to expire. Please change your password！',
    PASSWORD_EXPIRED_MESS: 'Your password has expired. Please change your password！',
    CLIENT_ROLE_ENTITY: 'Entity cant be empty!',
    TOPIC_NAME_001: 'Duplicate accounts name!',
    USER_DELETE_002: 'Can not delete a site owner!',
    MASTER_DATA_INVALID_004: 'Duplicate keys!',
    ENTITY_HAVECHILD_DELETE: 'Please delete the sub-entity(ies) before you can delete this entity!',
    ENTITY_NODE_SELECT: 'Please select a node!',
    INSIGHTS_NO_DATA: 'No Data',
    ENTER_MESSAGE_CONTENT: 'Please enter the message',
    placeholder_enter_email: 'Enter user working email address',
    INSIGHT_MSG_TITLE: '配置KPMG Executive Education！',
    CONFIG_FILE_LIMIT:
        'KCC will alert the Site Administrator when the files downloaded by each the KPMG or client user exceeds the value set below (* the value of ‘0’ means unlimited)',
    LIMIT_CYCLE: 'CYCLE',
    LIMIT_NUM: 'NUM',
    OR: 'OR',
    DOWNLOAD_AUTH: 'Allow client users to download the files uploaded from each other?',
    EXCHANGE_TAB_CONTROL: 'Turn on the ‘Group Reporting’ tabs to collaborate with the component teams?',
    EXCHANGE_TAB_CONTROL_des:
        'Activating this button will enable to invite any KPMG member (KPMG HK/Macau/Huazhen/Overseas) to access this KCC site. Are you sure to continue?',
    UNIT_01: 'day',
    UNIT_02: 'pcs',
    UNIT_03: 'Percentage',
    OPEN_LITE_AUTHORITY_WARNING:
        'Switching this button on will enable client users download the files uploaded by each other. Are you sure activate it functionally?',
    CLOSE_LITE_AUTHORITY_WARNING: 'Are you sure to close the button?',
    COMMON_TIP: 'Tips',
    REVERSEAUTH_TIP: 'Apply this PBC item to all client roles!',
    CANCLE_OPERATION: 'cancel the operation',
    CLIENT_ROLE_MSG:
        'Please set up the PBC lists and folders before creating roles!  Should new PBC lists/PBC items/folders etc be later added, please update roles configurations according to refreshed users’ access to the newly added content!',
    PBC_SELECT_STATUS: 'Select status',
    PBC_SELECT_TOPS: 'Select accounts (keyword)',
    PBC_TOPIC_DESC_TIP: 'Relevant Data Elements (keyword)',
    PBC_REVERSE_AUTH:
        'Do you confirm to make this PBC item be checked in all client roles? \n(Pre-condition: The PBC List which this PBC item belongs to should already be checked in client roles!)',
    PBC_DASHBOARD: 'PBC Chart Display ',
    PBC_INFO: 'PBC Collection Progress Dashboard',
    FORM_VALIDATE_COMMENTS_MAX: 'comments no more than 400 words!',
    NEW_COMMENTS_NULL: 'Please enter comments!',
    prompt_download: 'Downloading',
    loading:'Loading ...',
    SITE_ADD_NEW_ITEM_LLP: 'KPMG Huazhen Engagement',
    SITE_ADD_NEW_ITEM_LLP_TIP: 'Is this KCC site for KPMG Huazhen Engagement?',
    SITE_ADD_NEW_ITEM_OVERSEA: 'Is this KCC site for KPMG Hong Kong/Macau engagement?',
    SITE_ADD_NEW_ITEM_KCC_SITE_TIP: 'Is this KCC Lite?',
    CROSS_BORDER_CONTROL_POLICY:
        'To follow the data cross-border policies, this site of KPMG Huazhen engagement does not allow to grant access to KPMG Hong Kong or Macau staff',
    CROSS_BORDER_CONTROL_TITLE: "The Staff Can't Be Added",
    USER_PROFIT_001: `Important Notice of cross-border data policies!<br>If engagement code legal entity is KPMG Hongkong: corresponding KCC site blocks adding KPMG Huazhen staff or overseas member firm KPMG staff.<br>If engagement code legal entity is KPMG Huazhen: corresponding KCC site blocks adding KPMG Hongkong/Macau staff or overseas member firm KPMG staff.<br>Except KPMG China/HK will act as group auditor and use KCC to collect deliverables from other KPMG components, then other KPMG offices staff(HK/Macau/Huazhen/Overseas) can be invited to access the ‘Group Reporting’ tile ONLY.`,
    DOWNLOAD_FILE_NAME: 'File Name',
    DOWNLOAD_SIZE: 'File Size',
    DOWNLOAD_BY: 'Last Download By',
    FILE_DOWNLOAD_BY: 'Download By',
    DOWNLOAD_TIME: 'Last Download Datetime',
    UPLOAD_BY: 'Uploaded By',
    UPLOAD_TIME: 'Uploaded Time',
    HISTORY: 'History',
    VERSION_HISTORY: 'Version Histories',
    IMPORT_ENTITY_BUTTON: 'Import client organization structure',
    addEntityTips: 'Hover your mouse over the entity name to add,delete or edit!',
    entity_upload_info_title: 'Important Notice!',
    entity_upload_info1:
        'Every time the re-import of client organization file will overwrite  the existing client organization structure on site!',
    entity_upload_info2:
        'If existing Client organization structure already relates to roles, PBC lists or Category folders, re-import will be blocked!',
    FILE_NAME_LABEL: 'Filename',
    ENTITY_FILE_NAME_LABEL: 'Upload client organization structure file',
    ACCOUNT_FILE_NAME_LABEL: 'Upload tailored accounts file',
    ERROR_DETAIL_LABEL: 'Error Details',
    CLOSE_BUTTON: 'Close',
    FAQ_TITLE: 'FAQ',
    KCC_portal_TITLE: 'KCC Portal',
    FAQ_HEADER_TITLE: 'Frequently asked client questions about KCC!',
    FAQ_KCC_Q1: 'What is KCC？',
    FAQ_KCC_A1: `Click on this <a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">short KCC introduction video</a> to have an overview of these KCC features.`,
    FAQ_KCC_Q2: 'How to login to KCC?',
    FAQ_KCC_A2: `Click on this <a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">1 minute video</a> which shows you the steps to login to KCC.`,
    FAQ_KCC_Q3: 'How to submit audit materials (PBC) to KCC?',
    FAQ_KCC_A3: `Click on this <a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">short training video</a> which teaches you how to upload files to KCC.`,
    FAQ_KCC_Q4: 'What else information can I obtain from KCC?',
    FAQ_KCC_A4: `Click on this <a style="color: blue;" href={href} target="_blank" style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;">KCC more functions in a nutshell</a> video to have an overview.`,
    FAQ_SERIAL_TITLE1: 'Login',
    FAQ_SERIAL1_Q1: `Where and how do I start using KCC?`,
    FAQ_SERIAL1_A1: `KCC is web-based solution. Click <a style="text-decoration: underline;color: rgb(65, 138, 179);font-weight: bolder;" href={href} target="_blank">here</a> to access your KCC portal and login with your registered working eMail address, password and verification code, which will be sent to your registered email box.`,
    FAQ_SERIAL1_Q2: `What browser(s) does KCC support?`,
    FAQ_SERIAL1_A2: `It is recommended to use Google Chrome, Microsoft Edge or Microsoft IE 10/11 or above to optimise KCC performance.`,
    FAQ_SERIAL1_Q3: `I failed to receive a notification email with my initial KCC access password.`,
    FAQ_SERIAL1_A3: `Click your KPMG engagement team for help!`,
    FAQ_SERIAL1_Q4: `I failed to receive the verification code for login to KCC.`,
    FAQ_SERIAL1_A4: `Click on the ‘Contact Us’ button on KCC login page to get support from KPMG KCC Help Desk.`,
    FAQ_SERIAL1_Q5: `Can I receive the verification code via my mobile device?`,
    FAQ_SERIAL1_A5: `No. The verification code will be sent to your registered work email address.`,
    FAQ_SERIAL1_Q6: `Can I extend my KCC login expiration time to avoid having to frequently login?`,
    FAQ_SERIAL1_A6: `Yes. In the upper right hand corner of the KCC Home Page, you can find the ‘Configure Timeout’ button in the dropdown list. You can extend the login expiration time from the default half hour to 8 hours.`,
    FAQ_SERIAL1_Q7: `What to do if I forget my password?`,
    FAQ_SERIAL1_A7: `Click on the ‘Forgot Password?’ button in the login page. You can set a new password easily!`,
    FAQ_SERIAL1_Q8: `How to change my password?`,
    FAQ_SERIAL1_A8: `In the upper right hand corner of the KCC Home Page, you can find the ‘Change Password’ button in the dropdown list.`,
    FAQ_SERIAL1_Q9: `Can I connect to KCC via mobile devices?`,
    FAQ_SERIAL1_A9: `No.`,
    FAQ_SERIAL1_Q10: `Does KCC support dual language?`,
    FAQ_SERIAL1_A10: `Yes. KCC supports both English and Chinese. In the upper right-hand corner of the KCC Home Page, you can find the language switching button in the dropdown list.`,
    FAQ_SERIAL_TITLE2: 'Files',
    FAQ_SERIAL2_Q1: `What file formats does KCC support?`,
    FAQ_SERIAL2_A1: `KCC supports following file formats: (.xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg). For any special file formats that are not on this list, you can convert them into a .zip file before uploading them to KCC.`,
    FAQ_SERIAL2_Q2: `What is the single file size limitation on KCC?`,
    FAQ_SERIAL2_A2: `Single file size should be no greater than 1GB.`,
    FAQ_SERIAL2_Q3: `Can I open a file directly in KCC?`,
    FAQ_SERIAL2_A3: `No. You need to download the file first.`,
    FAQ_SERIAL2_Q4: `Is a history of the file versions maintained in KCC?`,
    FAQ_SERIAL2_A4: `Yes. Access the uploaded files list, and you can find the ‘Version Histories’ of each individual file in last column.`,
    FAQ_SERIAL2_Q5: `How do I easily identify files uploaded by the KPMG team or by my team?`,
    FAQ_SERIAL2_A5: `Files uploaded by the KPMG team are highlighted with a blue background color.`,
    FAQ_SERIAL2_Q6: `Why do the files names in KCC appear garbled?`,
    FAQ_SERIAL2_A6: `This may be because the browser auto-translation function is switched on. Please switch it off and check again.`,
    FAQ_SERIAL_TITLE3: 'Others',
    FAQ_SERIAL3_Q1: `Who to contact if I have KCC issue or I have suggestions?`,
    FAQ_SERIAL3_A1: `Click on the ‘Contact Us’ button on your KCC homepage and raise any issues that you are experiencing (with attachments) or comments that you may have. The KPMG KCC Help Desk will respond to your message.`,
    FAQ_SERIAL3_Q2: `Can KCC access permissions be segregated between our different working groups or entities?`,
    FAQ_SERIAL3_A2: `Yes. Client access supports multi-level permissions controls: from Entities to Tiles, to specific Information Request lists and even specific topics in each PBC request list. This function makes it very flexible to address varied access-control requirements.`,
    FAQ_SERIAL3_Q3: `How is my KCC authorisations and permissions managed?`,
    FAQ_SERIAL3_A3: `KCC authorisations and permissions are managed by the KPMG engagement team. Your access to KCC can be tailored per your roles and responsibilities.`,
    FAQ_SERIAL3_Q4: `I have some non-PBC documents to share with the KPMG team. How do I do this?`,
    FAQ_SERIAL3_A4: `The ‘Joint Working’ tile allows you to exchange non-PBC related files with the KPMG team.`,
    FAQ_SERIAL3_Q5: `Some of the PBC requests items are not applicable. What should I do?`,
    FAQ_SERIAL3_A5: `In the dropdown list of column ‘Source of Information’, you can mark it as ‘Not Applicable’, and it will be highlighted to the KPMG team.`,
    FAQ_SERIAL3_Q6: `How can I see an overview of the PBC submission progress?`,
    FAQ_SERIAL3_A6: `The PBC dashboard function enables you to oversee and track uploaded and outstanding PBC items in real-time manner. You can find the button<i class="el-icon-s-data" style="background-color: rgb(161, 114, 169);color: #ffffff;"></i> on the right side of the PBC page.`,
    FAQ_SERIAL3_Q7: `Appears that the data in the ‘PBC Dashboard’ is not complete?`,
    FAQ_SERIAL3_A7: `The ‘PBC Dashboard’ shows the PBC data that you are authorised to see. Try to ‘Clear all filter conditions’ and check again.`,
    FAQ_SERIAL3_Q8: `How can I communicate with the KPMG team about identified Audit matters?`,
    FAQ_SERIAL3_A8: `Hover your mouse over the matter status icon and click on the edit<i class="el-icon-edit" style="color: rgb(76, 161, 157);"></i> button to post your comments with supporting files, if any.`,
    FAQ_SERIAL3_Q9: `Can I edit data in the Statutory Account Status tile?`,
    FAQ_SERIAL3_A9: `No. It is read only.`,
    FAQ_TABLE_TITLE1: 'Provided by Client (PBC)',
    FAQ_TABLE_DES1: 'Efficient and transparent PBC submission and tracking',
    FAQ_TABLE_TITLE2: 'Joint Working',
    FAQ_TABLE_DES2: 'Easy file sharing with clients & Online questionnaire of client ‘IT Understanding’',
    FAQ_TABLE_TITLE3: 'Statutory Accounts Status',
    FAQ_TABLE_DES3: 'Real-time completion status of audit of the statutory accounts',
    FAQ_TABLE_TITLE4: 'Matter Logs',
    FAQ_TABLE_DES4: 'Matters timely communicated to facilitate resolution and to avoid surprises',
    FAQ_TABLE_TITLE5: 'Insights',
    FAQ_TABLE_DES5: 'The growth partner of the enterprise. Interesting, informative, and storytelling.',
    TOPIC_TYPE: {
        _1: 'CP',
        _2: 'FS-Banking',
        _3: 'FS-Insurance',
        _4: 'FS-Leasing',
        _5: 'FS-Securities',
        _6: 'FS-FUND',
        _7: 'ITA'
    },
    PBC_LIST_TIPS: `*Please check with your KCC Site Administrator (by default this will be your engagement manager) that your have been authorised appropriately in order that you are able to create and/or access PBC list(s)!`,
    JOINT_WORKING_ADD_TIPS: `*Please check with your KCC Site Administrator (by default this will be your engagement manager) that your have been authorised appropriately in order that you are able to create and/or access PBC list(s)!`,

    max_speed_title: 'Recommendations to maximise KCC speed',
    upload_file_valid: `File is marked as <i class="el-icon-circle-check" style="color: #67C23A"></i> when validation of uploaded file is complete (this may take seconds or minutes depending on the individual file size)`,
    upload_tip: `Do not close the window until all files are uploaded and validated, as shown by  ‘<i class="el-icon-circle-check" style="color: #67C23A"></i> '!`,
    page_tip: '(Best speed!)',
    page: 'Page',
    upload_btn_show:
        "(After files have been selected or dragged & dropped here, please click the 'Upload' button to start uploading files!)",
    pbc_batch_upload_tip: 'Configure all current page items',
    PBC_ACCEPT_CONFIRM_MSG:
        'Upon ‘Accepted’, this PBC item will block any further updates including more files uploading (existing files allow download). Are you sure to continue?',
    FILE_DELETE_WARNING_MSG: 'This file including its history versions will be permanently deleted! Are you sure to continue?',
    FILE_DELETE_WARNING_MSG_ONLY: 'This file will be permanently deleted! Are you sure to continue?',
    BEFORE_CLOSE_WARING_MSG: 'File uploading is in progress, close the window will terminate the file uploading! Still confirm to close?',
    COMMON_NOTIFY: 'Notice',
    pbc_notify_temp: `<div>The "client entities filter button<i class="fa fa-sitemap" style="background: #7213ea;color: #fff; padding: 5px"></i>" was optimized! Should some PBC items are not displayed, please click <i class="fa fa-sitemap" style="background: #7213ea;color: #fff; padding: 5px"></i> to confirm the selected entities!</div>`,
    no_assign: 'No Assignee',
    patch_set_role: 'Batch Managing Access',
    onkeyUpdateClientRolesConfirm: '一键更新至所有client roles？',
    show_search_conditions: 'Show the Filter Conditions',
    hide_search_conditions: 'Hide the Filter Conditions',
    select_all: 'Select All',
    unselect_all: 'Unselect all',
    patch_delete: 'Batch Delete Items',
    please_sent_initial_password:
        'Not all client users have been sent the initial password to login to KCC! Click this button to email your client users the initial password and KCC link to enable them to start using KCC!',
    i_know: 'I got it!',
    pbc_email_notice: 'This reminder email will be copied to yourself and all site administrators at the same time.',
    send_me_a_preview: 'Send to Myself for Preview',
    preview:'preview',
    please_select_visible_site: 'Please select the engagement sites cards that you want to show or hide on this dashboard',
    please_select_visible_site_placeholder: 'All KCC sites are hidden! Please select and show them!',
    create_date: 'Creation Date',
    Created_Date: 'Created Date ',
    last_role_delete:
        'After all role permissions are removed, clients may not be able to login KCC, and be blocked to access the "PBC/Joint Working/Statutory Account Status/Matters Log/KPMG Executive Education" tiles. Are you sure you want to continue?',
    patch_delete_user: 'Batch Deleting Users',
    patch_delete_client_user_forbid: 'Active client users can not be deleted! Please switch off the ‘Active’ button and try again!',
    patch_methods: 'Batch Operation',
    reminder_on_PBC_list_page:
        'Should a new PBC list be created, or more PBC items/entities be added, please update "Client Roles" configurations accordingly to refresh users’ access to the newly added content!',
    reminder_when_adding_new_joint_working_folder:
        'Should new folders be added or additional entities selected for a folder, please update "Client Roles" and "KPMG Roles" configurations accordingly to refresh users’ access to the newly added folders!',
    BATCH_export: 'Export Files Records ',
    Export_PBC_Items: 'Export PBC Items',
    Export_exchange_Items: ' Export All Items',
    Export_fapiao_Items: 'Export All Fapiao Information',
    Export_invoice_Items: 'Export All Invoice Information',
    send_client_user_placeholder: 'Select client recipient(s)',
    USER_ACCOUNT_IN_FILE_NOT_IN_WHITELIST:
        'The client user email suffix is not on the whitelist. Please add it first via button "Set Email Whitelist"!',
    USER_NAME_IN_FILE_IS_BLANK: 'Client ‘User name’ can not be blank! Please supplement it and try again!',
    USER_ACCOUNT_IN_FILE_IS_REDUPLICATIVE: 'There are duplicated client email address! Please double check and try again.',
    form_code_type: 'Code Type',
    updatePbcGroup_topicDesc_overlength: '导入模板中，“已识别的相关数据要素”部分单元格内容过多！不可超过250个汉字 （或250个英文字母）！',
    site_code: 'Engagement Code ID',
    site_type: 'Code Type',
    site_status: 'Code Closed?',
    team_member: 'Number of authorised KPMG team members',
    client_user: 'Number of invited client users',
    file_upload_number: 'Number of uploaded files',
    file_upload_size: 'Size of uploaded files',
    file_download_size: 'Total ever-downloaded file size',
    file_download_number: 'Total ever-downloaded file number/Number of downloads',
    general_site_code_info:
        '<span>Engagement Code ID：{code}</span><span style="margin-left: 50px;">Code Type：{code_type}</span><span style="margin-left: 50px;">Code Closed?：{is_roll}</span>',
    site_code_type_long_master: 'Master engagement code',
    site_code_type_long_sub: 'Sub-engagement code ',
    site_code_type_long_opp: 'Opportunity code',
    site_code_type_long_bd: 'Business Development code',
    roll_forward_notice_1:
        '! ALL uploaded files and communications in this KCC site were deleted when this engagement code [{code}] was ‘Closed’! Should you want to recycle use of this KCC site structure for the current period’s audit work, please submit an OAK ticket <a target="_blank" style="color: #3879eb; font-weight: 600; text-decoration: underline;" href="http://cnshaapp103.cn.kworld.kpmg.com/OAK/User/CreateTicketFromProfiles.aspx">\'KCC Site Set-up Service>Roll-forward the existing KCC site structure\'</a> to update this KCC site IBS engagement code (‘the mapped engagement code’) to the current period’s one! Otherwise, this KCC site will be automatically deleted on [{date}]!',
    roll_forward_notice_2:
        '! An IBS engagement code (Master engagement code or Sub-engagement code) is required for a KCC site!  Please approach the <a target="_blank" style="color: #3879eb; font-weight: 600; text-decoration: underline;" href="mailto:CN-FM%20KPMG%20Collaboration%20Centre%20%3ccnfmkpmgclicbt@kpmg.com%3e">KCC Team</a> to update the currently mapped {codeType} [{code}] to the current period’s IBS engagement code when it is available! ',
    roll_forward_notice_3:
        '! ALL uploaded files and communications in this site will be deleted automatically when this engagement code [{code}] is set to ‘Closed’ in IBS! Please download the uploaded files should you need them! ',
    aDashboard_title: 'PBC Collection Retrospective Dashboard',
    table_columns_display_btn: 'Hide / Show columns',
    file_upload_date: 'file upload date',
    file_upload_start_date: 'Upload start date',
    file_upload_end_date: 'Upload end date',
    general_code_info_title: "This KCC site IBS Engagement Code Information ('the mapped engagement code')",
    file_exist: 'This record is exist,please do not add it repeatedly!',
    head_video_mask: 'Watch this short guidance video to learn how to submit PBCs easily!',
    column_forbid_hidden: 'This column is not allowed to be hidden',
    CLIENT_STATACC_STATE: 'The entity cannot be deleted because its statutory accounts status is not initial.',
    CLIENT_MATTER_ENTITY_BIND: 'The entity cannot be deleted because it is already associated with matter logs.',
    CLIENT_ROLE_ENTITY_BIND: 'The entity cannot be deleted because it is already associated with a role.',
    PBC_ENTITY_BIND: 'This entity cannot be deleted because it is already associated with the PBC manifest.',
    CATEGORY_ENTITY_BIND: 'The entity cannot be deleted because it is already associated with exchanges.',
    client_role_setting_guidance_A:
        'No PBC list found of the selected entities. Please first set up the PBC list(s) in PBC tile before the client roles configuration and authorization!',
    client_role_setting_guidance_B: 'Please select the PBC list(s) to authorise access!',
    client_role_setting_guidance_C: ' Please select the items in the PBC list(s) to authorise access!',
    client_role_setting_exchange_empty: 'Please select the folder(s) in Joint Working tile to authorise access!',
    client_role_setting_admin_empty: 'Please select the folder(s) in Client Admin tile to authorise access!',
    SITE_OWNER_IS_EMPTY: 'Site leader cannot be empty',
    SITE_ADMIN_IS_EMPTY: 'Site administrator cannot be empty',
    UNIT: 'Unit',
    table_header_label_code_type: 'Code Type',
    RolledForward: 'Code Closed?',
    SiteInfoModifiedTime: 'Site Profile Modified Time',
    outstanding_PBC_requests_count: 'Outstanding PBC Items',
    outstanding_PBC_requests_count_TIP: 'Status= “Overdue” or “Upcoming due” or “Revision Required”',
    client_submitted_but_pending_KPMG_confirmation_PBC_requests_count: 'Uploaded PBC Items',
    client_submitted_but_pending_KPMG_confirmation_PBC_requests_count_tip: 'Status= “Uploaded”',
    KPMG_accepted_PBC_requests: 'Accepted PBC Items',
    KPMG_accepted_PBC_requests_tip: 'Status= “Accepted”',
    submitted_before_deadline_pbc_request: 'Submitted Before Due Date',
    submitted_before_deadline_pbc_request_tip:
        'Client last uploaded date ≤ Due date(*)<br/><em>*The set-up due date before client starts uploading files</em>',
    overdued_pbc_count: 'Submitted After Due Date',
    overdued_pbc_count_tip:
        'Client last uploaded date ≤ Due date(*)<br/><em>*The set-up due date before client starts uploading files</em>',
    overdued_on_average: 'Overdue Days On Average',
    revision_required_count: 'Number of ‘Revsion Required’ Requested',
    rsdashboard_level1: 'Level 1',
    rsdashboard_level2: 'Level 2',
    rsdashboard_level3: 'Level 3',
    pbc_items_total: 'Total PBC Items',
    pbcDashboardTooltip: 'PBC Collection Progress Dashboard',
    pbcRsDashboardTooltip: 'PBC Collection Retrospective Dashboard',
    Due_Date_can_not_edit: 'Due Date can not be changed when clients start uploading files!',
    Filter_per_Entity: 'Filter per Entity',
    login_welcome_1: 'WELCOME TO',
    login_welcome_2: 'KCC!',
    // kcc最佳体验建议------------------------start------------------------
    kcc_max_speed_kp_tip1: `Use <span style="color: #3879eb;">Microsoft Edge</span> browser to access KCC`,
    kcc_max_speed_kp_tip2: `Single file size kept to less than <span style="color: #3879eb;">500MB</span>`,
    kcc_max_speed_kp_tip3: `Size of multiple file downloads in one go kept to less than <span style="color: #3879eb;">500MB</span>`,
    kcc_max_speed_kp_tip4: `Upload large files (greater than 500MB) <span style="color: #3879eb;">one-by-one</span>`,
    kcc_max_speed_kp_tip5: `In the “PBC” and “Joint Working” tiles, set the number of items displayed on the same page to <span style="color: #3879eb;">10</span>`,
    kcc_max_speed_kp_tip7: 'Upload and download large files or large volumes of  files:',
    kcc_max_speed_kp_tip7_1: `in the KPMG <span style="color: #3879eb;">office</span>`,
    kcc_max_speed_kp_tip7_2: `<span style="color: #3879eb;">outside normal office hours</span>`,
    kcc_max_speed_kp_tip7_3: `using a KPMG <span style="color: #3879eb;">wired</span> connection`,
    kcc_max_speed_client_tip1: `Use <span style="color: #3879eb;">Microsoft Edge</span> browser to access KCC`,
    kcc_max_speed_client_tip2: `Single file size kept to less than <span style="color: #3879eb;">500MB</span>`,
    kcc_max_speed_client_tip3: `Upload large files (greater than 500MB) <span style="color: #3879eb;">one-by-one</span>`,
    kcc_max_speed_client_tip4: `In the “PBC” and “Joint Working” tiles, set the number of items displayed on the same page to <span style="color: #3879eb;">10</span>`,
    click_to_upload: 'Upload',
    // kcc最佳体验建议------------------------end------------------------

    // ----------------Confirmation---------------------------------------------
    confirmation_dashboard_title: 'Audit Confirmations Authorisation Progress Overview',
    confirmation_dashboard_query_entity: 'Audited Entity',
    confirmation_dashboard_query_type: 'Confirmation Type',
    confirmation_dashboard_chart1_title: 'Progress Overview',
    confirmation_dashboard_chart2_title: 'Progress Analysis',
    confirmation_dashboard_chart2_des_part1: 'Bank confirmation authorisation takes',
    confirmation_dashboard_chart2_des_part2: 'Non-bank confirmation authorisation takes',
    confirmation_dashboard_chart2_des_part3: 'days on average',
    confirmation_dashboard_chart3_title: 'Analysis of Confirmations Pending for Authorisation',
    confirmation_dashboard_chart3_title_part1: 'Confirmations pending for authorisation for more than ',
    confirmation_dashboard_chart3_title_part2: 'days',
    confirmation_dashboard_table_title: 'Audit Confirmation Progress of Each Audited Entity',
    confirmation_status: {
        _1: 'Under preparation',
        _2: 'Pending for authorisation',
        _3: 'Stamped/signed and sent to KPMG <br /> (for hardcopy confirmations)',
        _3_3: 'Stamped/signed and sent to KPMG (for hardcopy confirmations)',
        _4: 'Sent to Addressee',
        _5: 'Received by addressees but not yet responded',
        _6: 'Returned'
    },
    status_operate_tip: `<span style="color: #fd349c">(Please stamp and sign)</span>`,
    confirmation_type: {
        _0: 'Non-bank confirmation',
        _1_all: 'Bank confirmation',
        _1: 'Bank confirmation-hardcopy',
        _2: 'Bank confirmation-electronic',
    },
    confirmationGuide: 'Confirmation Operation Guidelines',
    confirmationGuideTips: 'Please click on the relevant bank name to download and review the authorization guidance, then proceed to complete the authorization process through the designated online channel.',
    total: 'Total',
    minimum: 'Minimum  value',
    maximum: 'Maximum value',
    show_confirmation_overview: 'Show Confirmation progress overview',
    hide_confirmation_overview: 'Hide Confirmation progress overview',
    confirmation: {
        homepage: {
            tab: {
                dashboard: 'Dashboard',
                details_list: 'Confirmation list'
            }
        },
        details_list: {
            confirmationTip_kp:
                'The audited entity’s person responsible for audit confirmations should complete authorisation on the authorisation page of each confirmation. For guidance on stamping and signature of audit confirmations,please click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">the video series of Audit Confirmation Strategy.</a>If you have any questions regarding KCC operations, please click to find <a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/OAK%20documents/KPMG%20internal%20use%20Quick%20reference%20card%20-%20Use%20of%20KCC%20Audit%20Confirmation%20tile.EN.pdf" target="_blank">the guidance</a> and  <a style="color: #3879eb;font-weight:600" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mef2c9wg" target="_blank">the KCC demonstration video.</a>',
            confirmationTip_client:
                'The audited entity’s person responsible for audit confirmations should complete authorisation on the authorisation page of each confirmation. For guidance on stamping and signature of audit confirmations,please click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">the video series of Audit Confirmation Strategy.</a>If you have any questions regarding KCC operations, please click to find <a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/OAK%20documents/KPMG%20internal%20use%20Quick%20reference%20card%20-%20Use%20of%20KCC%20Audit%20Confirmation%20tile.EN.pdf" target="_blank">the guidance</a> and  <a style="color: #3879eb;font-weight:600" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mef2c9wg" target="_blank">the KCC demonstration video.</a>',
            confirmationTip_2: 'Click to Audit Confirmations Authorisation Progress Overview',


            zhizhi_kp: '- For hardcopy confirmations, please print out the confirmation and arrange the stamping/signature according to the Authorisation Key Points (<a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/Shared%20Documents/Hardcopy%20Audit%20Confirmations/%E5%AE%A1%E8%AE%A1%E7%94%A8%E8%AF%A2%E8%AF%81%E5%87%BD%E2%80%94%E2%80%94%E6%8E%88%E6%9D%83%E8%A6%81%E7%82%B9.pdf" target="_blank">《审计用询证函-授权要点》</a>).',
            zhizhi_client: '- For hardcopy confirmations, please print out the confirmation and arrange the stamping/signature according to the Authorisation Key Points (<a style="color: #3879eb;font-weight:600" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/Shared%20Documents/Hardcopy%20Audit%20Confirmations/%E5%AE%A1%E8%AE%A1%E7%94%A8%E8%AF%A2%E8%AF%81%E5%87%BD%E2%80%94%E2%80%94%E6%8E%88%E6%9D%83%E8%A6%81%E7%82%B9.pdf" target="_blank">《审计用询证函-授权要点》</a>).',
            dianzi: "-  For electronic confirmation, click the information icon (<i class='el-icon-link' style='color: #3879eb;'></i>) next to the confirmation addressee's name (located under the 'Addressee' column in the confirmation list) to review the <a style='color: #3879eb;font-weight:600' href='/#/confirmation-guide' target='_blank'>authorization guidance</a>, then proceed to complete the authorization process through the designated online channel.",

            videoTipKp: `<div style="color: #14263b;">1. To know more about the KCC Audit Confirmation tile, click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mef2c9wg">the KCC Audit Confirmation video</a> or read <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://spo-global.kpmg.com/sites/CN-OI-BUS-KDC/OAK%20documents/KPMG%20internal%20use%20Quick%20reference%20card%20-%20Use%20of%20KCC%20Audit%20Confirmation%20tile.EN.pdf">the instruction</a>; 2. For guidance on stamping and signature of audit confirmations, click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">the video series of Audit Confirmation Strategy.</a>.</div>`,
            videoTipClient: `<div style="color: #14263b;">1. To know more about the KCC Audit Confirmation tile, click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://home.kpmg/cn/zh/home/insights/2022/08/the-audit-confirmation-tile-on-kcc.html">the KCC Audit Confirmation video</a> or read <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://assets.kpmg/content/dam/kpmg/cn/pdf/en/2022/08/quick-reference-card.pdf">the instruction</a>; 2. For guidance on stamping and signature of audit confirmations, click to watch <a style="color: #3879eb; font-weight: 600;" target="_blank" href="https://players.brightcove.net/3755095886001/default_default/index.html?videoId=6286913947001">the video series of Audit Confirmation Strategy.</a>.</div>`,
            btns: {
                download_confirmation: 'Download confirmations',
                print_confirmation: 'Print confirmations in batch',
                export_list: 'Export the confirmation list',
                update_status: 'Mark confirmations sent to KPMG in batch',
                clear: 'Clear the filter',
                reprint: 'Need to stamp/sign again'
            },
            operate_tip: 'Select the audit confirmations and then click the above button:',
            table: {
                unique_id: `Confirmation ID`,
                unique_id_nocss: `Confirmation ID`,
                confirmation_type: 'Confirmation Type',
                entity_name: 'Audited  Entity',
                addressee_entity_name: 'Addressee',
                balance_sheet_date: 'Balance Sheet Date',
                ticketNo: 'Ticket No.',
                client_responsible_person: 'Responsible Person of the Audited Entity',
                kpmg_responsible_person: 'KPMG Responsible Person',
                client_authorisation_status: 'Confirmation Status',
                confirmation_status: 'Details of Confirmation Status <br/><span style="color:#fd349c;">(For KPMG only)</span>',
                confirmation_status_no_br: 'Details of Confirmation Status <span style="color:#fd349c;">(For KPMG only)</span>',
                days_of_pending_for_authorisation: 'Number of Days Since Uploading Confirmation',
                confirmation_uploaded_time: 'Date Confirmation Uploaded by Confirmation Centre',
                current_status_time: 'Date Confirmation Status Last Changed',
                courier_no: 'Courier Number Sending Confirmations to KPMG',
                input_comments: 'Comments',
                historical_comments: 'Historical Records',
                courier_no_2: 'Courier Number Sending Confirmation to addressees',
                dateDeliveredToAddressee: 'Date confirmation received by addressees',
                number_of_days_since_received: 'Number of Days Since Received by Addressees but not yet Responded'
            },
            not_print: 'Not printed',
            updateStatusForm: {
                courier_no: 'Courier Number Sending Confirmations to KPMG'
            }
        }
    },
    confirmation_superuser_open_tip: 'Warning:User will be granted all confirmations access of this client, Do you confirm?',
    sync_from_IBS: 'IBS Automatic Sync',
    please_check_list_wanna_edit: 'Audit confirmations are not selected.',
    confirmation_print_oversize: 'The maximum size of batch print file is 1GB, please select again.',
    please_choose_status_or_input_Courier_no: 'Please choose status or input Courier no.',
    please_input_Courier_no: 'Please input Courier no.',
    check_valid_data: 'Please select valid data',
    common_empty: 'Empty',
    begin_date: 'Begin date',
    end_date: 'End date',
    kprole_entity_confirmation_tip:
        '（KPMG team members are permitted to view all the contents in "Audit Confirmation" and “Client Admin” tiles, which is not restricted by the selected entities of assigned role(s).） ',
    kpuser_role_confirmaion_tip:
        'KPMG team members are permitted to view all the contents in "Audit Confirmation" tile, which is not restricted by the assigned role(s).',
    kpuser_partstaff_confirmaion_tip: 'Can only access the ‘Group Reporting’ tabs in ‘Joint Working’ tile.',
    serialNo: 'Serial Number #',
    serialNoPlaceholder: 'e.g.: 5 or 5,6,7 or 5-7',
    courierNoErr: 'The tracking number is 10-30 digits, letters, and dashes',
    deprecatedTicketTip: `Reminder: Ticket {ticketList} stop update in KCC.  Please don’t input any information of confirmations under the above ticket(s) (including confirmation status, courier number or comments).  If you need to view the confirmations or check the updated status, please contact with KPMG responsible person.`,
    exchangeCategory: {
        _1: 'Confirmations',
        _2: 'Reports',
        _3: 'Templates',
        _4: 'Analysis',
        _5: 'TOD sample',
        _6: 'Group Audit Instructions',
        _7: 'Group Accounting Manual',
        _8: 'Specific instructions',
        _9: 'Documentation for procedures performed at group level',
        _10: 'Deliverables submission',
        _11: 'Guidelines',
        _12: 'Instructions'
    },
    fileNameKeyword: 'File Name (Keyword)',
    batchDeleteUserConfirm:
        'If the user is now accessing this KCC site, please remind the user to log out of this KCC site upon he/she is deleted!',
    sas_status: 'Status',
    sas_date_fix: 'Status update datetime',
    sas_date_cust: 'Custome datetime',
    milestone_title: 'Milestone name',
    target_datetime: 'Target Date',
    confirmation_cannot_download_tip:
        'Due to data cross-border control, the file cannot be previewed/downloaded. Please contact KPMG responsible person.',
    export_list: 'Export the list',
    client_visable: 'Client visable',
    disabled: 'Disabled',
    genral_cos_please_config_switch: 'Please select the function tiles by switching them on or off',
    genral_cos_please_config_tiles: 'Please further configure each function tile',
    config_pbc_tile: 'Provided by Client (PBC)',
    config_joint_title: 'Joint Working',
    config_group_audit_title: 'Group Reporting',
    config_exchange_title: 'Joint Working',
    config_Statutory_milestone: 'Statutory Accounts Status (Milestones)',
    config_insights_item: 'KPMG Executive Education',
    config_confirmation: 'Confirmation',
    general_tile_confirmation: 'Audit Confirmation',
    table_column_lable_milestone: 'Milestone',
    table_column_lable_deadline: 'Need a ‘Target Date’ column?',
    table_placeholder_deadline: 'Set a date',
    table_column_lable_remarks: 'Remarks',
    table_column_lable_client_show: 'Milestone visible to client?',
    table_column_lable_action: 'Action',
    export_statutory_list: 'Export Statutory List',
    enable_interim_audit: 'Enable Interim Audit or not?',
    general_tiles_interim_audit_switch: 'Turn on the ‘Interim’ tab?',
    general_tiles_vat_audit_switch: 'Turn on the ‘VAT Information‘ tab?',
    allow_component_down_upload: 'Allow component teams to download the files uploaded by the group auditors?',
    enable_ITU: 'Enable IT Understanding',
    add_milestone: 'Add Milestone',
    rename_milestone: 'Rename Milestone',
    dialog_title_warning: 'Warning',
    confirm_delete_milestone: 'Are you sure to delete this milestone?',
    please_input_milestone_name: 'Please input milestone name:',
    milestone_file_visible_to_client: 'Visible to client?',
    for_kpmg_only: '(for KPMG only)',
    sas_confirm_set_visible: 'Are you sure to make this file visible to authorised client users?',
    sas_confirm_set_invisible: 'Are you sure to hide this file to authorised client users?',
    MILESTONE_CANNOT_UPDATE: 'Cannot update milestone.',
    sas_dashboard_title: 'Statutory Accounts Status Dashboard',
    each_milestone_completion_time_allocation: 'Each milestone completion & time allocation',
    each_milestone_progress_overview: 'Each milestone progress overview',
    all_entities_progress_overview: 'All entities progress overview',
    sas_dashboard_examples_14: 'Completed or Not Applicable',
    sas_dashboard_examples_23: 'In Progress or Not Started',
    milestone_completion_alert:
        'Upon ‘Completed’ or ‘Not Applicable’, this milestone status will block any further updates! Are you sure to continue?',
    confirm_not_editble_2:
        'When the progress status is ‘Submitted to Group’, neither the group auditor or the component team will be able to continue uploading more files or deleting the uploaded files. Are you sure to continue?',
    confirm_not_editble_4: 'Upon ‘Approved by Group Team’, it will block any further updates! Are you sure to continue?',
    forbid_update_status: 'Status updating is forbidden.',
    Notify_Client_About_Report_Progress: 'Notify Client About Report Progress',
    Notify_Client_About_Uploaded_Draft_Reports: 'Notify Client About Uploaded Draft Reports',
    recevier: 'Client recipient(s)',
    ccer: 'Copy KPMG Team Member(s)',
    exchange_tab1_recevier: ' Component recipient(s)',
    exchange_tab1_ccer: 'Copy',
    clear_filter: 'Clear All Filters',
    move_left: 'Move left',
    move_right: 'Move right',
    rename: 'Rename',
    printed: '(Printed)',
    MILESTONE_DATA_INVALID_001: 'Milestone data invalid',
    MILESTONE_DATA_INVALID_002: 'Milestone data invalid',
    milestone_name_invalid: 'Milestone name invalid',
    milestone_name_invalid_special_char:
        'Save Failed! Milestone name description can not contain any of these special characters:\\ / : * ? < > | ” “ " , ，',
    base_info_setting: 'Basic Info',
    ask_for_save: 'The current page has been updated. Do you want to save it?',
    fold: 'Fold',
    unfold: 'Unfold',
    clientUserAddTitleTip:
        '*This client user account meanwhile has been invited to access KCC sites: {sites}, and will share this same KCC account information.',
    CANNOT_DELETE_LAST_FIRST_LEVEL_MILESTONE: 'Cannot delete last first level milestone.',
    SECOND_LEVEL_MILESTONE_NAME_REPEAT: 'Second level milestone name repeat.',
    First_LEVEL_MILESTONE_NAME_REPEAT: 'First level milestone name repeat.',
    none_of_level2_milestone: 'Level 2 milestone cannot be empty.',
    please_choose_recevier: 'Please select ‘To’ recipient!',
    milestone_title_tip:
        'Further changes to the milestone settings will be blocked when the milestone is working in progress (the milestone progress is updated or if any files uploaded)!',
    sas_title_tip:
        'To change or customize the milestones, the Site Administrator can do this via "General Settings > Manage Function Tiles". Click to find the <a style="color: blue;" href="https://spo-global.kpmg.com/:b:/r/sites/cn-oi-svc-AUD/KCC/Quick%20reference%20card%20-%20KCC%20%27Statutory%20Accounts%20Status%27%20tile.pdf" target="_blank" style="color: #3879eb; font-weight: 600;text-decoration: underline;">quick reference card</a>. ',
    milestone_cannot_update_tooltip:
        'The latter milestone can be started only when the previous milestone is ‘Completed’ or ‘Not Applicable’！',
    sas_upload_tip:
        'The KPMG team uploaded files in ‘Statutory Account Status’ tile is by default not visible to the clients. To adjust the visibilities to clients, please go to the ‘Files’ list!',
    delete_file: 'Delete File',
    sas_delete_file_text: 'Are you sure to delete this file?',
    none_of_update_data: 'No data has been updated',
    please_select_role: 'Please select role.',
    file_upoloaded_by_kp: 'KPMG engagement team',
    file_downloaded_by_kp: 'Client',
    file_downloaded_by_client: 'Client',
    businesshome_left_title_kcc_sites: 'KCC sites',
    businesshome_left_title_kcc_tiles: 'KCC tiles',
    businesshome_left_title_files_uploaded_by: 'Files Uploaded By',
    businesshome_left_title_files_downloaded_by: 'Files Downloaded By',
    businesshome_left_title_upload_time: 'Upload Time',
    businesshome_left_title_download_time: 'Download Time',
    businesshome_right_row1_title_1: 'Total number of uploaded files',
    businesshome_right_row1_title_2: 'Total size of uploaded files',
    businesshome_right_row1_title_3: 'Number of downloaded files',
    businesshome_right_row1_title_4: 'Size of download files',
    businesshome_right_row1_title_5: 'Total number of downloads',
    businesshome_right_row1_title_pcs: 'PCS',
    businesshome_right_row1_title_times: 'Times',
    businesshome_right_table1_title: "Overview of Files 'Download by'",
    export_the_list: 'Export the list',
    table_column_downloaded_by: 'Downloaded by',
    table_column_total_number_of_files: 'Total Number of Files<br/>(unique per file ID)',
    table_column_size_of_downloaded_files: 'Size of downloaded files<br/>(unique per file ID)',
    grand_total: 'Grand Total',
    alter_setting: 'Alert Setting',
    downloaded_date: 'Download Date ',
    export_downloaded_files_list: 'Export List',
    downloaded_files: 'Downloaded Files',
    kcc_tile: 'Title',
    alert_engagement_manager:
        'The engagement manager will be alerted via email if client user’s downloaded Files In Two Weeks exceed the volume set above.',
    email_address: 'E-mail address',
    size: 'Size',
    detailed_download_records: 'Detailed Download Records',
    please_input_valid_serino: 'Please enter valid serialNo filtering string.',
    if_show_confirmation_reply_status: 'Show the details of returned confirmations?',
    you_can_input_day_count_will_auto_refresh:
        'You can enter the number of days in the text box, and the chart data will be automatically updated.',
    echarts4_subtitle:
        '(<span style="color:#fd349c;">Click</span> on the charts and graphs to <span style="color:#fd349c;">filter</span> confirmations from the confirmation list.)',
    please_input: 'Please input',
    confirmation_bar4_inputtip_1: 'To be signed and stamped by the audited entity for more than or equal to __ days',
    confirmation_bar4_inputtip_2:
        'The confirmed party has signed for but has not received a reply, which is greater than or equal to __ days',
    confirmation_echart4_title: 'Analysis of correspondence that has been pending for a long time',
    confirmation_replyRate_analysis: 'Reply Rate Analysis',
    confirmation_replyRate_analysis_comment: 'Returned / Sent out to Addressees',
    reprint_reason: {
        _1: 'Overlapping seals',
        _2: 'Vague seals',
        _3: 'Seals missing',
        _4: 'Cross-page seal missing / incomplete',
        _5: 'The seal is inconsistent with the name of the audited entity',
        _6: 'Other, Please specify'
    },
    reprint_dialog_title: 'Need to stamp/sign again',
    reprint_dialog_tip:
        'Please <span style="color: #ff2121">select</span> or fill in the reason(s) for reprinting confirmations to arrange stamping/signature, then click "confirm". <span style="color: #ff2121">A reminder email will be sent</span> to the audited entity\'s confirmation responsible person, and the related confirmations\' "printed" tag will be removed.',
    reason: 'Reason',
    please_input_reason: 'Please input others reason',
    reprint_please_choose_reason: 'Please choose or fill reason.',
    onlyNotElectronic: 'Only non-e-mail entries can be checked',
    confirmation_count: 'Confirmation Count',
    KCC_short_introduction: 'KCC short introduction',
    settingHomeTipHtml:
        'Watch the guidance video of <a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk" target="_blank">‘Set up your KCC site’</a>',
    settingHomeTipLink: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk',
    sendNotifyEmailTipHtml:
        'Click to find <a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=11&zoom=100,0,0" target="_blank">guidance</a>',
    sendNotifyEmailLink:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=11&zoom=100,0,0',
    downloadPBCTipHtmlKp:
        'Watch the guidance video of <a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_hewfrpun" target="_blank">\'Download PBC Files’</a> ',
    downloadPBCTipHtmlClient:
        'Watch the guidance video of <a style="color: blue;" href="javascript:void(0)" @click="showClientVideo()">\'Upload PBC Files’</a>',
    downloadPBCTip_1: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_hewfrpun',
    downloadPBCTip_2: '',
    sas_tip_html:
        'Click to find <a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Quick%20reference%20card%20-%20KCC%20\'Statutory%20Accounts%20Status\'%20tile.pdf?cid=beb99804-4208-4af4-a534-4543e0fd9220" target="_blank">guidance</a> and <a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_p69ykdc1" target="_blank">demonstration video</a>',
    sas_tip_link:
        "https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Quick%20reference%20card%20-%20KCC%20'Statutory%20Accounts%20Status'%20tile.pdf?cid=beb99804-4208-4af4-a534-4543e0fd9220",
    confirmation_title: 'Audit Confirmation List',
    pbc_rsdashboard_tip:
        '<a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Forms/AllItems.aspx?id=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC%2F%27PBC%20Retrospective%20Dashboard%27%20Guidance%2Epdf&parent=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC" target="_blank">Quick Guidance</a>',
    pbc_rsdashboard_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/Forms/AllItems.aspx?id=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC%2F%27PBC%20Retrospective%20Dashboard%27%20Guidance%2Epdf&parent=%2Fsites%2Fcn%2Doi%2Dsvc%2DAUD%2FKCC',
    businesshome_tip:
        'Click to find <a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=10&zoom=100,0,0" target="_blank">guidance</a>.',
    businesshome_tip_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=10&zoom=100,0,0',
    exchange_tip_kp:
        'Click to find <a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=4&zoom=100,0,0" target="_blank" target="_blank">guidance</a>',
    exchange_tip_link_kp:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20Usage%20Tips%20and%20New%20Features.pdf#page=4&zoom=100,0,0" target="_blank',
    ITU_tip:
        'Click to find <a style="color: blue;" href="https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20%27IT%20Understanding%27%20tab%20-%20Quick%20Reference%20Card.pdf" target="_blank">the using guidance.</a>',
    ITU_tip_link:
        'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/KCC/KCC%20%27IT%20Understanding%27%20tab%20-%20Quick%20Reference%20Card.pdf',
    split_file_tip:
        'Split big file that exceeds 1GB using <a style="color: blue;" href="/winrar_cn.pdf" target="_blank">WinRAR</a> or <a style="color: blue;" href="winzip_cn.pdf" target="_blank">WinZIP</a> before uploading it to KCC.',
    split_file_tip_link: '/winrar_cn.pdf',
    ita_status_not_started: 'Not started',
    ita_status_in_progress: 'In progress',
    ita_status_icon_completed: 'Completed',
    ita_btn_notify_client: 'Notify Client About Outstanding Questionnaire',
    ita_btn_archive_questionnaire: 'Export Questionnaire',
    pagination_all: 'All',
    ita_add_qa: 'Add Questionnaire',
    ita_table_header_section: 'Section',
    ita_section: {
        _1: 'IT Organization',
        _2: 'IT Strategy',
        _3: 'IT Procedures',
        _4: 'IT Systems',
        _5: 'Networking',
        _6: 'Cyber Security'
    },
    ita_table_header_status: 'Status',
    ita_table_header_client_responsible: 'Client Responsible',
    ita_table_header_period_date: 'Year-end Date',
    ita_table_header_due_date: 'Due Date',
    ita_table_header_last_update_by: 'Last Updated By',
    ita_table_header_last_update_time: 'Last Updated Time',
    ita_table_header_delete: 'Detele',
    freetable_add_more: 'Add more',
    freetable_input_placeholder: 'Please enter {key}',
    freetable_input_others_placeholder: 'Please enter others {key}',
    freetable_select_placeholder: 'Please select {key}',
    ita_choose_files: 'Choose Files...',
    ita_upload_tip:
        'Up to 100 files can be uploaded; each single file size should be no greater than 100MB! File formats that are supported: xls,xlsx,doc,docx,ppt,pptx,pdf,pps,ppsx,csv,txt,jpg,jpeg,png,zip,rar,7z,xlsm,xlsb,msg.',
    ita_please_check_rows: 'Please check rows you will edit.',
    site_delete_notice:
        'Are you sure to proceed with deleting the KCC site?<br/>Engagement Code:{code}<br/>Site Name: {siteName}<br/>Client Name: {clientName}',
    kpt_member_add_notice:
        'Notice: Should this invited staff is from overseas KPMG member firm, please make sure you have submitted this staff information and his/her location office IP range to KCC Team and completed the required configuration to enable his/her access to this KCC site!',
    ita_unsave_answer_notice: 'Not saved. Are you sure you want to exit?',
    client_role_enable_itu: 'IT Understanding',
    itu_auto_saving: 'Automatic saving...',
    itu_auto_saving_html: 'Now saving questionare info automatically...',
    itu_delete_notice: 'All questionaire of this entity will be deleted.',
    itu_please_check_rows_export: 'Please check rows you will export.',
    itu_please_answer_all_question: 'Please answer all questions.',
    itu_please_check_rows_notice: 'Please check rows you will send to notice client.',
    itu_list_delete_forbid: 'Questionaire was forbidden to delete which in this status.',
    itu_list_delete_forbid_2: 'There are questionnaires in a status where deletion is not allowed under this entity.',
    next: 'Next',
    gotIt: 'Got it!',
    filterFunction: 'The filter functionalities have been moved here. ',
    guidanceTip: 'You can always find the related KCC using guidance by clicking on the light bulb.',
    KPMGExecutiveEducation: 'The growth partner of our client. Interesting, informative, and storytelling!',
    fileTracking: 'Click this button to real-time check the client users’ download records.',
    newFapiaoTip:'You can find the engagement invoice and fapiao information here!',
    ITUnderstanding: 'New ‘IT understanding’ tile to collect IT information from clients to support the audit.',
    confirmationStatus: 'Newly upgraded to show real-time confirmation return status!',
    sourceType_matterLog: 'Matter Logs',
    sourceType_confirmation: 'Audit Confirmation',
    sourceType_jointWorking: 'Joint Working',
    sourceType_pbc: 'PBC',
    sourceType_statutory: 'Statutory Accounts Status',
    new_tag: 'New',
    total_downloaded_files: 'Total Downloaded Files',
    few_days_later_input_disallow: 'Days input disallow',
    itu_upload_limit: 'Allow up to 100 files to be uploaded',
    site_add_notice: 'Please make sure the site legaal entity is correct before you save it, It cannot be modified anymore once saved!”',
    itu_entity_add_repeat: 'Add entity repeat：{entities}',
    confirmation_only_can_reprint_printed_rows: 'You can only select printed rows.',
    client_download_title_1: 'Total Downloaded Files In Two Weeks',
    client_download_title_2: 'Total Downloaded Files In Two Weeks',
    itu_summary_lock: 'Current questionire was locked by {username}, please try 5 minutes later.',
    kee_menu_1: 'Accounting Courses',
    kee_menu_2: 'Taxation Courses',
    kee_menu_3: 'Hot Topics',
    kee_menu_4: 'Audit Cooperation',
    kee_menu_5: 'Insights and News',
    kee_menu_1_desc: 'The latest and most comprehensive accounting courses, updated annually, covering everything in one place！',
    kee_menu_2_desc: 'A series of courses on taxation in various regions，  to help enterprises keep abreast of tax trends！',
    kee_menu_3_desc: 'Various hot topic courses enable you to follow the industry trend accurately! ',
    kee_menu_4_desc: 'Empower and improve the efficiency of interaction with auditing！',
    kee_my: 'Favourite',
    kee_online_courses: 'Online course',
    kee_offline_courses: 'In-person Activities',
    kee_duration: 'Duration',
    kee_free: 'Free',
    kee_charge: 'Charge',
    kee_like: 'Like',
    kee_remove_like: 'Remove like',
    kee_viewed: 'Viewed: {num}',
    kee_course_column: 'Catalogue',
    kee_duration_2: 'Duration',
    kee_WITHDRAW: 'Wthdraw',
    kee_offline_detail_disabled: "You can't visit detail which course is offline.",
    kee_completeness: 'Completeness',
    kee_play: 'Play',
    kee_course_desc: 'Course Description',
    kee_price: 'Price',
    kee_detail: 'Course Detail',
    recommendTitle: 'Executiver Education',
    startCourse: 'Start',
    kee_discount: 'Discount',
    scan_qr_for_register: 'Scan QR code for registration',
    kee_kp_view_in_mp: 'Internal users watch in KPMG internal training system',
    confirmation_dashboard_filtered: 'The confirmation list is filtered.',
    confirmation_bubble_1: 'Select confirmations pending for authorisation',
    confirmation_bubble_2: 'Select all',
    confirmation_bubble_3:
        '1. Print, stamp and sign, and send confirmations back to KPMG. <br/>2. Mark the status as "Stamped/signed and sent to KPMG".',
    confirmation_bubble_4: 'Monitor confirmation status',
    confirmation_bubble_5: 'Confirmation status overview and long-outstanding confirmations',
    dashboard_bubble_1: 'Select audited entity or confirmation type',
    dashboard_bubble_2: 'Click on the charts and graphs to filter confirmations from the confirmation list.',
    component_team_mgt: 'Component Team Management',
    'businesshome_codestatus_Set-up': 'Set-up',
    'businesshome_codestatus_In-use': 'In-use',
    businesshome_codestatus_Created: 'Created',
    businesshome_codestatus_Closed: 'Code Closed',
    activeTimeType_1: 'Account Created',
    activeTimeType_2: 'Send Initial Password',
    activeTimeType_3: 'Client Logon',
    activeTimeType_4: 'Activate Account',
    client_list_user_name: 'User Name',
    client_list_client_email: 'Client Email Address',
    datepicker_shortcut_recently_week: 'In Past Two Weeks',
    datepicker_shortcut_recently_month: 'In Past Month',
    datepicker_shortcut_recently_3month: 'In Past Three Months',
    datepicker_shortcut_recently_6month: 'In Past Six Months',
    datepicker_shortcut_recently_year: 'In Past Year',
    date_filter_begin: 'Date',
    date_filter_end: 'Date',
    date_filter_middle: '~',
    faq_1: 'https://spo-global.kpmg.com/sites/cn-oi-svc-AUD/SitePages/KCCQAs-EN.aspx',
    faq_2: '/faq_en.pdf',
    comming_soon: 'coming soon',
    kee_video_tip_1:
        'Watch the demonstration <a style="color: blue;" href="https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mwqfynjx" target="_blank">video</a>',
    kee_video_tip_2:
        'Watch the demonstration <a style="color: blue;" href="https://kpmg.com/cn/zh/home/insights/2023/09/kcc-new-features-business-deployment.html" target="_blank">video</a>',
    kee_video_link_1: 'https://kpmgcn.mediaspace.sg.kaltura.com/media/0_mwqfynjx',
    kee_video_link_2: 'https://kpmg.com/cn/zh/home/insights/2023/09/kcc-new-features-business-deployment.html',
    kee_my_empty: 'No favourite course',
    kee_my_empty1: 'No course viewed',
    authorise:{
        title:'Authorise your clients to view the Fee Invoices and Fapiao information!',
        p1:"The KCC 'Client Admin' tile automatically captures and summarises engagement Fee Invoices, Fapiao information, Payment status, and VAT information. ",
        step1:'Go to "Client Users" page',
        step2:'Authorise the client user via cloumn "Access Level"',
        ok:'OK',
        okTips:'I will authorise now.',
        no:'Got it!',
        noTips:'I will authorise later when invoice(s) issued!'

    },
    admin: {
        entityName: 'Entity Name',
        description: 'Description',
        signingDate: 'Signing Date',
        contractType: 'Contract Type',
        contract: 'Contract',
        fee: 'Fee Agreements',
        vat: 'VAT Information',
        entityNameEn: 'Entity Name-En',
        entityNameCn: 'Entity Name-Cn',
        entityId: 'EntityID',
        fapiaoRegistrationNumber: 'Fapiao Registration Number',
        fapiaoAddress: 'Fapiao Address',
        fapiaoPhoneNumber: 'Fapiao Phone Number',
        bankAccount: 'Bank Account',
        bankAccountHolder: 'Bank Account Holder',
        enterTip: 'Please enter {name}',
        selTip: 'Please select {name}',
        downloadTpl: 'Download Template',
        invoices: 'Invoices',
        invoice:'Invoice',
        issuanceDate: 'Issuance Date',
        feeAmount: 'Fee Amount',
        totalAmount: 'Total Amount',
        invoiceCurrency: 'Invoice Currency',
        invoiceNumber: 'Invoice Number',
        invoiceContactEmail: 'Invoice Contact Email',
        status: 'Payment Status',
        overdueDays: 'Overdue Days',
        feeNote: 'Fee Note',
        fapiao:'Fapiao',
        fapiaoTips:'One or more Fapiao(s) are issued against multiple invoices.',
        fapiaoToEntity:'Client Entity',
        fapiaoAmount:'Fapiao Total Amount(CNY)',
        fapiaoIssueDate:'Fapiao Issue Date',
        fapiaoType:'Fapiao Type',
        fapiaoNumber:'Fapiao Number',
        fapiaoReferenceCode:'Fapiao Reference Code',
        fapiaoPdf:'Fapiao(PDF)',
        fapiaoXml:'Fapiao(XML)',
        "08":'Electronic special VAT invoice',
        "10":'Electronic normal VAT invoice',
        "81":'Fully digitalized special VAT invoice',
        "82":'Fully digitalized normal VAT invoice',
        selectionTips:'Which type of file you want to download?',
        bill:'Bill',
        pdf:'PDF',
        xml:'XML',
        overdueDaysDes: '{t} days overdue',
        overdueDaysFullDes: 'Paid {t} days late',
        NA: 'NA',
        overdueDaysRange: 'Overdue Days Range',
        overdueDaysRangeError: 'The overdue days start date is greater than the end date',
        toProvided: 'To be provided',
        'System synchronisation': 'System synchronisation',
        'NOT PAID': 'NOT PAID',
        'FULLY PAID': 'FULLY PAID',
        'PARTIALLY PAID': 'PARTIALLY PAID',
        CANCELLED: 'CANCELLED',
        'Engagement letter/Client contract': 'Engagement letter/Client contract',
        Proposal: 'Proposal',
        'Statements of Work or Work Orders': 'Statements of Work or Work Orders',
        'Multi-firm engagement (KPMG China as an originating firm)': 'Multi-firm engagement (KPMG China as an originating firm)',
        'Multi-firm engagement (KPMG China as an participating firm)': 'Multi-firm engagement (KPMG China as an participating firm)',
        'Local Implementation Agreement': 'Local Implementation Agreement',
        'Non-disclosure Agreement': 'Non-disclosure Agreement',
        'Personal Non-disclosure Agreement / Individual Confidentiality Undertaking':
            'Personal Non-disclosure Agreement / Individual Confidentiality Undertaking',
        'Contract with 3rd party (e.g. subcontractor agreement, alliance agreement)':
            'Contract with 3rd party (e.g. subcontractor agreement, alliance agreement)',
        'Simplified (abridged) Chinese engagement letter (for filing purposes in Mainland China)':
            'Simplified (abridged) Chinese engagement letter (for filing purposes in Mainland China)',
        'Others (Please explain)': 'Others (Please explain)',
        enterKeyword: 'Please enter a keyword',
        settlementDate: 'Settlement Date',
        dataDeadline:'Data as of:',
        invoiceTip1:"Invoice data shown is as per KPMG's records of the previous working day.",
        invoiceTip2:"Any invoice settlements made may take several days to match and process and therefore result in a delay in updating 'Payment Status'."
    },
    pdwComplexity:{
        important:"Important:",
        tips:'Starting from 15 August 2024, KPMG China are implementing additional security controls to enhance the protection of your data. One of these initiatives is to require passwords to have <span class="important">a minimum length of 12 characters</span>. Please update you password beforehand to avoid any access issues.',
        ok:'OK.',
        okTips:'I will update my password now.',
        noted:'Noted. ',
        notedTips:'I will update my password later.',
        topTips:'Starting from 15 August 2024, KPMG China requires <span class="important">a minimum password length of 12 characters</span> for enhanced security of your access!'
    },
    login:{
       step: "Step",
       step1:"Account",
       step2:"Password",
       step3:"Verification code",
       SMS:"Via SMS",
       Email:"Via Email",
       next:"Login",
       continue:"Continue",
       phone:"Mobile number",
       forgot:"Verification code",
       confirmPassword:"Confirm New Password",
       newPassword:"New Password",
       forgotAccount:"Account (E-mail)",
       emptyPhone:"Mobile number is required！",
       validatePhone:"The Mobile number format is incorrect.",
       emptyVerification:"Verification code is required！",
       china:"+86 China",
       HongKong:"+852 Hong Kong, China",
       Macau:"+853 Macau, China",
       changePassword:"Enter new password"
    },
    TABLE_HEADER_CLIENT_ENTITIES:"Authorised Client Entities",
    MEMBER_TABLE_HEADER_CLIENT_ENTITIES:"Authorised Component(s)",
    TABLE_HEADER_Access_Level:"Access Level",
    CLIENT_TABLE_HEADER_Access_Level:"Access Level",
    CLIENT_TABLE_HEADER_CLIENT_ENTITIES:"Authorised Client Entities or Roles",
    TABLE_HEADER_Client_Entities:"Authorised Client Entities",
    Batch_Access:"Batch Managing Access",
    TABLE_HEADER_KP_Access_Level_Tip:"SPECIFIC(Entities)<br>* user can always access all content in the 'Client Admin', ‘Audit Confirmation’, <br>'KEE', and ‘Group Reporting – Shared Documents’ tiles!",
    CLIENT_TABLE_HEADER_Access_Level_Tip:"ALL<br> * the 'Group Reporting' tile is always hidden to client.<br><br> SPECIFIC(Entities)<br>*a) user can always access all content in the 'Client Admin'\,<br>'KEE' tiles\,and his/her responsible confirmations in<br>'Audit Confirmation' tile; b) the 'Group Reporting' <br> tile is always hidden to client.",
    TABLE_HEADER_Access_Level_Tip:"ALL<br> *the 'GroupReporting' tiles is always hidden to client <br><br> SPECIFIC(Entities)<br>*a)user can always access all centent in 'Client Admin'\,<br>'KEE' tiles\,and his/her responsible confirmations in<br> 'Audit Confirmation'title; b)the 'Group Reporting'<br> tile is always hidden to client.",
    tailored_tip:"Are you sure to make thie client user can always access all entities content across all KCC tiles?",
    tailored_warning:"Important Notice!",
    USER_WORKING_PHONE:"Mobile Number",
    SMS_PHONE_DUPLICATED:"The verification code can not be sent again within 60 seconds! Please try again later. ",
    SMS_PHONE_ERROR:"SMS sending failed! Please check the phone number and get code again.",
    SMS_PHONE_FORMAT:"SMS sending failed! Please check the phone number and get code again.",
    SMS_ERROR:"SMS system error! Please contact your KPMG engagement team to get help.",
    SMS_PHONE_UNIQUE:"The mobile phone number has been registered by another account! ",
    ALL_OPTION:"ALL",
    SPECIFIC_OPTION:"SPECIFIC (Entities) ",
    SPECIFIC_OPTION2:"SPECIFIC (Components) ",
    TAILORED_OPTION:"TAILORED",
    All_ENTITIES:"All entities",
    All_COMPONENTS:"All components",
    SELECT_TYPE:"Select entities",
    SELECT_ROLE_TYPE:"Select assigned roles",
    login_step1_tip:"The account is your working email address.",
    login_step2_tip:"For first-time logon, please enter the initial password that<br>has been sent to your registered work email address.",
    CLIENT_NOTICE:"The access management of client users has been simplified and migrated here!<br>Step 1: Select 'Access Level'<br>Step 2: Select'Authorised Client Entities or Roles'<br>Done!",
    KP_NOTICE:"The access management of KPMG team members has been simplified and migrated here!<br>Step 1: Select 'Access Level'<br>Step 2: Step 2: Select 'Authorised Client Entities'<br>Done!",
    COMPONENTS_NOTICE:"The access management of component team members has been migrated here!<br>Step 1: Select 'Access Level'<br>Step 2: Step 2: Select 'Authorised Components'<br>Done!",
    MEMBER_TABLE_HEADER_KP_Access_Level_Tip:"*Component user can always access the content in<br>“Group Reporting – Shared Documents” tab.",
    ROLE_CHANGE_TIP:"You have selected and authorised all client entities, thus the ‘Access Level' will be automatically adjusted to 'ALL'.",
    groupDashboardTooltip: 'Group Reporting Dashboard',
    groupDashboardTooltipDrawer: 'Group Reporting - Deliverables Collection Dashboard',
    workbench: 'Work Bench',
    clientDashboard: {
        regulatoryPolicy: 'Regulatory/Policy',
        tech_transformation: 'Tech for Transformation',
        insights: 'Insights',
        KEE: 'KPMG Executive Education (KEE)'
    },
    FILE_UPLOAD_007: 'Upload failed! System is busy, and please try again later!',
    kpmgFinanceOnline: '毕马威财税在线',
    qrcodeTips: '手机扫一扫获取更多课程',
    required: 'Required',
}
